import React, { useState, useContext, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import { RestaurantContext } from "../../../../../../contexts/Restaurant";
import { SettingsContext } from "../../../../../../contexts/Settings";
import { UserContext } from "../../../../../../contexts/User";
import { BASE_URL } from "../../../../../../BaseUrl";
import { gsap } from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import "react-datepicker/dist/react-datepicker.css";
//functions
import {
  _t,
  getCookie,
  getSystemSettings,
  checkPermission,
  getVoucherUsage,
  setApiTime,
  isTimeExpired,
  checkBetweenTime,
  checkNetworkStatus
  // restaurantMenuLink,
} from "../../../../../../functions/Functions";
import { useCustomHooks } from "../../../../../../functions/Hooks";
// custom styles
// import "./pos.css";

import { FoodContext } from "../../../../../../contexts/Food";
import {
  calculatePriceForCartItem,
  calculateSubTotal,
  createHash,
  getTax,
  setItemOnEdit,
  getServiceCharges,
  calculatePriceForCartVariation,
  getInitialItemDiscount,
  getItemDiscount,
  getTaxPrice,
} from "./../helpers";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useReactToPrint } from "react-to-print";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import useFOCManagerVerify from "../../../../../../hooks/useFOCManagerVerify";
import { ToastError } from "../../../../../../functions/ToastShow";

gsap.registerPlugin(MotionPathPlugin);

const usePosLogics = () => {

  // CONTEXTS
  const {
    //submitted orders
    // submittedOrders,
    // setWorkPeriodList,
    // workPeriodList,
    getRunningOrders,
    runningOrders,
    //work period
    workPeriodListForBranch,
    setWorkPeriodListForBranch,

    //branch
    branchForSearch,
    branchForListSearch,

    //table
    getTable,
    //dept-tag
    deptTagForSearch,
    //payment-type
    paymentTypeForSearch,

    orderTypeList,
    //Scheme
    schemeForSearchObj,
    schemeForSearch,
    cardForSearch,
    orderCounter
  } = useContext(RestaurantContext);

  const { loading, setLoading, syncOrder, generalSettings } = useContext(SettingsContext);

  const { authUserInfo, partyForSearch, managerPasscode } = useContext(UserContext);

  const {
    //food
    foodGroupForPOSById,
    //food group
    //foodGroupForSearch,
    //setFoodGroupforSearch,
    getFoodGroupForPOS,
    menuForPos,
    getOrderDetails,
    //property group
    propertyGroupForSearch,
    //food stock

    //food grop with menu
    availableFoodGroups,
    isStockLoading: isFoodLoading,
  } = useContext(FoodContext);

  const {
    //customer
    getWaiter,
    // getParty,
    // partyList,
  } = useContext(UserContext);
  const { t } = useTranslation();

  //edit order
  const { order_id } = useParams();

  const stockListenerRef = useRef(null);

  const { onlineOrder, availableDeliveryTypes, availableDeliveryParties, fetchStock, roundOffPrice, totalPriceWithTax, checkTaxType, taxPercent, handleCustomerOrderUpdate, syncLocalOrders, getOfflineApiUrl, handleSubmitOffline, getSubtotalInclusiveSettle, getDynamicOfflinePrintUrl } = useCustomHooks();
  const offline = (url) => {
    return !navigator.onLine && localStorage.getItem(url) != null;
  };
  let history = useHistory();
  const paymentOptions = ["Cash", "Card", "Online"];
  // STATES
  const [loyaltyPoint, setloyaltyPoint] = useState({
    qr_code: "",
    availablePoints: 0,
    maxRedeemPoints: "",
    earnedPoints: 0,
    phn_no: "",
    redeemPoints: 0,
    verified: true,
    type: getSystemSettings(generalSettings, "loyality_enable") === "techmixers" ? "" : ("token"),
    customerName: "",
  });
  const inputSearch = useRef();
  const imageAnimate = useRef(null);
  const cardAnimate = useRef([]);
  const flyStart = useRef(null);
  const animate = useRef(null);
  const menuWisePrice = useRef(0);
  // overflow height style
  const taxHeight = useRef();
  const taxScroll = useRef()
  const discountInput = useRef(true);
  const deliveryInput = useRef(true);
  const token_No = useRef("");
  //print bills
  const componentRef = useRef();
  const component2Ref = useRef();
  const cardModal = useRef();
  const con_Kot = useRef("");
  const syncSettle = useRef(false);
  const commentFocus = useRef();
  const [workPeriodScreen, setWorkPeriodScreen] = useState(1)
  //payment type for call center
  const [selectedSwitch, SetSelectedSwitch] = useState();
  const currentNavPill = (element) => {
    SetSelectedSwitch(element);
  };
  const [callCenterPayment, setCallCenterPayment] = useState({
    payment_type: "Cash",
    transaction_no: "",
    transactionModal: false,
  });

  //add comments
  const [commentId, setCommentId] = useState();

  //checked properties
  //const [selectedProperties, setSelectedProperties] = useState([]);
  //print states
  const [foodGroupsToPrint, setFoodGroupsToPrint] = useState(null);

  //FBR Invoice Num
  // const [fbrInvoiceNum, setFbrInvoiceNum] = useState(null);
  // //FBR Invoice Nums
  // const [srbInvoiceNum, setSrbInvoiceNum] = useState(null);
  const fbrInvoiceNum = useRef(null);
  const srbInvoiceNum = useRef({
    number: "",
    url: "",
  });
  const [userLock, setUserLock] = useState([]);
  const [kotPrintIdx, setKotPrintIdx] = useState(0);
  const [showordertypeModal, setShowordertypeModal] = useState(false);
  //card offer

  // edit delete states
  const [deleteReason, setDeleteReason] = useState("");
  const [addReasonModalShowing, setAddReasonModalShowing] = useState(null);
  const [addFocItem, setAddFocItem] = useState({
    modal: false,
    itemId: null,
    reason: ""
  });
  const [deletedItemsOnEdit, setDeletedItemsOnEdit] = useState({});
  const [itemAdd, setItemAdd] = useState();
  const [editKot, setEditKot] = useState();
  const [expanded, setExpanded] = useState(false);
  const [CatInOneLine, setCatInOneLine] = useState(false);
  //edit order state
  const [editOrder, setEditOrder] = useState(false);
  //print end
  // authenticate user
  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [componentUnlock, setComponentUnlock] = useState("");
  const [managerId, setManagerId] = useState(null)
  //back btn modal
  const [backModal, setBackModal] = useState(false);
  //note rider btn modal
  const [noteRiderModal, setNoteRiderModal] = useState(false);

  const [searchInput, setSearchInput] = useState("");
  const [selectedFoodItem, setSelectedFoodItem] = useState(null);
  const [selectedFoodItemId, setSelectedFoodItemId] = useState(null);
  //const [availableFoodGroups, setAvailableFoodGroups] = useState({});
  const [activeFoodGroup, setActiveFoodGroup] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedDeliveryType, setSelectedDeliveryType] = useState();
  const [selectedParty, setSelectedParty] = useState();
  const [totalsettle, setTotalSettle] = useState(0);
  const [theVatSettle, setTheVatSettle] = useState(0);
  const [theVat, setTheVat] = useState(0);
  const [newOrder, setNewOrder] = useState(null);
  const [showSettle, setShowSettle] = useState(false);
  const [calculatorMenu, setCalculatorMenu] = useState(false);
  const [modal9Show, setModal9Show] = useState(false);
  const [modal10Show, setModal10Show] = useState(false);
  // set order type modal in call center zone
  const [modalOrderType, setModalOrderType] = useState(false)
  //cart calculation states
  const [cartItems, setCartItems] = useState({});
  const [cartSubTotal, setCartSubTotal] = useState(0);
  const [cartTotal, setCartTotal] = useState(0);
  const [taxType, setTaxType] = useState("");
  const [selectedKot, setSelectedKot] = useState([]);
  const [paidMoney, setPaidMoney] = useState(0);
  const [newSettings, setNewSettings] = useState({
    vat: null,
    workPeriod: null,
  });
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const isSettle = useRef(0);
  const [theTax, setTheTax] = useState(0);
  const [deliveryCharges, setDeliveryCharges] = useState(0);
  const [serviceCharges, setServiceCharges] = useState(0);
  const [returnMoneyUsd, setReturnMoneyUsd] = useState(0);
  // const [deliveryTypeList, setDeliveryTypeList] = useState([]);
  // const [filteredDept, setFilteredDept] = useState(null);
  const [paymentTypeAvailable, setPaymentTypeAvailable] = useState(paymentTypeForSearch);
  const [tempSchemeForSearch, setTempSchemeForSearch] = useState(null);
  //const [tempQty, setTempQty] = useState(0);
  // const [selectGroup, setSelectGroup] = useState({});
  //table popup
  const [guestSelected, setGuestSelected] = useState(1);
  const [selectTable, setSelectTable] = useState({});
  const [tableId, setTableId] = useState(null);
  //zone address
  const [zoneArea, setZoneArea] = useState(null);
  const [area, setArea] = useState(null);

  //end
  const [searchedFoodItem, setSearchedFoodItem] = useState({
    searched: false,
    list: null,
  });

  // for bogo offers
  const [bogo, setBogo] = useState(0);
  //item image
  const [itemImage, setItemImage] = useState(false);
  // cash cheque pay in payout
  const [cashDetails, setCashDetails] = useState({
    work_period_id: null,
    branch_id: null,
    branch_name: null,
    party_id: null,
    party_name: null,
    payment_type: null,
    cheque_no: 0,
    cheque_date: null,
    payment_status: null,
    remarks: "",
    amount: 0,
  });
  // order details
  const [orderDetails, setOrderDetails] = useState({
    branch: null,
    table: null,
    waiter: null,
    card_number: "",
    payment_discount: null,
    payment_dis_type: "",
    card_number_settle: "",
    payment_type: null,
    payment_amount: null,
    total_guest: 1,
    table_id: null,
    table_name: null,
    service_amount: 0,
    note_to_rider: "",
    order_tip: 0,
    newCustomerInfo: {
      id: null,
      name: "",
      email: "",
      phn_no: "",
      address: "",
      ref_no: "",
      ntn_no: "",
      gender: "",
      dob: "",
      nearest_landmark: "",
      alt_phn_no: "",
      modal: false,
      order: null,
      is_confirm: false,
    },
    token: null,
    unique_token: null,
    order_No: null,
    serviceCharge: 0,
    is_reservation: 0,
    discount: 0,
    scheme: {
      scheme_id: null,
      scheme_name: "",
      cap_amount: 0,
      min_order_amount: 0,
      discount_amount: 0,
      open_discount: null,
      discount_type: "",
      how_much_discount: null,
      discount_addon: "",
      discount_tax: 0,
    },
    orderTypeDetails: {
      orderTypeId: null,
      orderTypeName: "",
    },
    partyDetails: {
      partyId: null,
      partyName: "",
      partyPercent: null,
      for_cc: 0,
    },
    pre_order_date: null,
    is_advance_booking: 0,
    is_edit: 0,
    pre_order_modal: false,
    advance_amount: 0,
    is_split: 0,
  });

  // State hooks here
  const [foodItem, setFoodItem] = useState({
    foodGroup: null,
    items: null,
    selectedItem: null,
    variations: null,
    properties: null,
  });
  // payment type tax modal
  const [paymentTypeModalState, setPaymentTypeModalState] = useState({
    showModal: false,
    taxCalSelect: false,
    subTotal: 0,
    vat: 0,
    vatAmount: 0,
    serviceCharge: 0,
    serviceChargeAmount: 0,
    deliveryCharges: 0,
    discount: 0,
    totalPayable: 0,
    payment_type_name: "",
  });
  const [availableDeptTags, setAvailableDeptTags] = useState([]);
  const [selectedDeptTag, setSelectedDeptTag] = useState("");
  console.log("kot1", orderDetails, newOrder);

  const workPeriodStatus = async (branchId) => {
    const pendingUrl = BASE_URL + `/settings/get-day-open-status/${branchId}`;
    try {
      const res = await axios.get(pendingUrl, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });

      if (res) {
        const isOpen = res?.data;
        setWorkPeriodScreen(isOpen);
        sessionStorage.setItem("wpRes", JSON.stringify(isOpen))
        if (!isOpen) {
          toast.error(
            "Please close your previous day and start a new day",
            toastObj
          );
        }
      }

    } catch (err) {
      console.error("Error fetching work period status:", err);
    }
  }

  useEffect(() => {
    if (authUserInfo && authUserInfo?.details) {
      if (isTimeExpired("running_orders")) {
        getRunningOrders();
        setApiTime("running_orders", 1); // Only hit API once per minute
      }
      if(authUserInfo?.details.user_type === "staff" || authUserInfo?.details.user_type === "waiter" || authUserInfo?.details.user_type === "manager"){
        let branchId = authUserInfo.details?.branch_id;
        if(isTimeExpired("wp")){
          workPeriodStatus(branchId)
          setApiTime("wp",15)
        }else if(sessionStorage.getItem("wpRes")){
          let wpRes = JSON.parse(sessionStorage.getItem("wpRes"))
          setWorkPeriodScreen(wpRes)
        }
      }
    }
  }, [authUserInfo]);

  useEffect(() => {
    let details = selectedSwitch?.getBoundingClientRect();
    const root = document.querySelector(":root");
    root.style.setProperty("--delivery-switcher-width", details?.width + "px");
    root.style.setProperty(
      "--delivery-switcher-height",
      details?.height + "px"
    );
    root.style.setProperty(
      "--delivery-switcher-left",
      selectedSwitch?.offsetLeft + "px"
    );
  }, [callCenterPayment?.payment_type, selectedSwitch]);

  // PACKAGES SETTINGS OBJECT
  const toastObj = {
    position: "bottom-center",
    autoClose: 10000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  const toastObj1 = {
    backgroundColor: "#0a8d6e",
    autoClose: 10000,
    style: {
      fontSize: "16.5px", // Set the font size in the style object
    },
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    className: "text-center toast-notification",
  };

  // check internet
  let networkStatus = true;

  const emptyCardEdit = () => {
    setCartItems({});
    setPaidMoney(0);
    setTheVat(0);
    setTheTax(orderDetails.branch?.branch_tax ? orderDetails.branch?.branch_tax : 0);
    setServiceCharges(0);
    setSelectedParty();
    setSelectedDeliveryType();
    setZoneArea(null);
    setArea(null);
    setSelectTable({});
    setUserLock([]);
    setManagerId(null);
    setGuestSelected(1);
    setOrderDetails((curr) => ({
      ...curr,
      token: null,
      unique_token: null,
      order_No: null,
      orderTypeDetails: {
        orderTypeId: null,
        orderTypeName: "",
      },
      partyDetails: {
        partyId: null,
        partyName: "",
        partyPercent: null,
        for_cc: 0,
      },
      card_number: "",
      payment_discount: null,
      payment_dis_type: "",
      card_number_settle: "",
      note_to_rider: "",
      order_tip: 0,
      newCustomerInfo: {
        id: null,
        name: "",
        email: "",
        phn_no: "",
        address: "",
        ref_no: "",
        ntn_no: "",
        gender: "",
        dob: "",
        nearest_landmark: "",
        modal: false,
        order: null,
        alt_phn_no: "",
        is_confirm: false,
      },
      serviceCharge: 0,
      discount: 0,
      scheme: {
        scheme_id: null,
        scheme_name: "",
        cap_amount: 0,
        min_order_amount: 0,
        discount_amount: 0,
        open_discount: null,
        discount_type: "",
        how_much_discount: null,
        discount_addon: "",
        discount_tax: 0,
      },
      total_guest: 1,
      is_reservation: 0,
      table: null,
      waiter: null,
      table_id: null,
      table_name: null,
      pre_order_date: null,
      is_advance_booking: 0,
      is_edit: 0,
      pre_order_modal: false,
      advance_amount: 0,
      is_split: 0,
    }));
    discountInput.current = true;
    setSearchedFoodItem({
      searched: false,
      list: null,
    });
    setSearchInput("");
    setEditOrder(false);
    if (inputSearch.current) inputSearch.current.value = "";
  }

  useEffect(() => {
    if (authUserInfo?.details && deptTagForSearch && availableFoodGroups && branchForListSearch && partyForSearch) {
      emptyCardEdit();
      if(order_id){
        if ((authUserInfo?.details?.user_type === "admin" || 
          authUserInfo?.details?.user_type === "superAdmin")) {
          setSelectedBranch(null);
          setTheTax(0);
          setNewSettings({
            vat: null,
            workPeriod: null,
          });
        }
        if (authUserInfo.details?.branch_id) {
          let theBranch = branchForListSearch && branchForListSearch[authUserInfo.details.branch_id];
          //set work period
          let theWorkPeriod = newSettings?.workPeriod;
  
          //set branch tax
          if (theBranch) {
            theWorkPeriod = workPeriodListForBranch &&
              workPeriodListForBranch.find((tempWorkPeriod) => {
                return (theBranch.id === parseInt(tempWorkPeriod.branch_id)) && tempWorkPeriod.ended_at === null;
              });
            //set work period here
            setNewSettings((curr)=>({
              ...curr,
              //vat: generalSettings && getSystemSettings(generalSettings, "type_vat"),
              vat: theTax !== 0 ? theTax : theBranch?.branch_tax,
              workPeriod: theWorkPeriod ? theWorkPeriod : null,
            }));
          }
        }
        if (authUserInfo.permissions !== null) {
          setLoading(true);
          if (checkPermission(authUserInfo.permissions, "Order edit")) {
            getOrderDetails(order_id).then((data) => {
              if (data) {
                setTimeout(() => {
                  handleEditOrder(data)
                }, 0);
                setTimeout(() => {
                  setStatesOnEditOrder(data);
                }, 120);
              }
            });
          }
          setLoading(false);
        }
      }else{
        if (authUserInfo.details?.branch_id) {
          let theBranch = branchForListSearch && branchForListSearch[authUserInfo.details.branch_id];
          //set work period
          let theWorkPeriod = newSettings?.workPeriod;
  
          //set branch tax
          if (theBranch) {
            theWorkPeriod = workPeriodListForBranch &&
              workPeriodListForBranch.find((tempWorkPeriod) => {
                return (theBranch.id === parseInt(tempWorkPeriod.branch_id)) && tempWorkPeriod.ended_at === null;
              });
            //set work period here
            setNewSettings({
              ...newSettings,
              //vat: generalSettings && getSystemSettings(generalSettings, "type_vat"),
              vat: theTax !== 0 ? theTax : theBranch?.branch_tax,
              workPeriod: theWorkPeriod !== undefined ? theWorkPeriod : null,
            });
            setTimeout(() => {
              setCashDetails({
                ...cashDetails,
                branch_id: theBranch && theBranch.id,
                branch_name: theBranch && theBranch?.name,
                work_period_id: theWorkPeriod && theWorkPeriod?.id,
              });
              // set branch for staff
              setOrderDetails((curr) => ({
                ...curr,
                branch: theBranch,
              }));
              setCounterDefaultDetails(theBranch);
              setTheTax(theBranch.branch_tax);
              handleFilterDept(theBranch.id);
            }, 15);
          } else {
            setTheTax(0)
          }
        } else {
          // user type admin
          let theBranch = branchForListSearch && branchForListSearch[authUserInfo.details.branch_id];
          //set branch tax
          if (theBranch) {
            handleFilterDept(theBranch.id);
            setTheTax(theBranch.branch_tax)
          } else {
            setTheTax(0)
          }
          setNewSettings({
            ...newSettings,
            vat: theTax ? theTax
              : ((theBranch && theBranch?.branch_tax) ? 
                theBranch.branch_tax : 0),
          });
        }
      }
    }

  }, [
    order_id,
    deptTagForSearch,
    branchForSearch,
    availableFoodGroups,
    partyForSearch,
  ]);

  const setCounterDefaultDetails = (branchSelected = null) => {
    if (authUserInfo?.details) {
      const defaultOrderTypeId =
        authUserInfo.details?.default_order_type_id ||
        authUserInfo.details?.default_order_id;
      const deliveryType =
        defaultOrderTypeId && Array.isArray(orderTypeList?.data)
          ? orderTypeList.data.find((delivery) => {
              return (
                delivery &&
                parseInt(delivery.id) === parseInt(defaultOrderTypeId) &&
                delivery.status === "On"
              );
            })
          : null;

      const defaultPartyTypeId =
        authUserInfo.details?.default_party_type_id ||
        authUserInfo.details?.default_party_id;
      const partyType =
        defaultPartyTypeId && Array.isArray(partyForSearch)
          ? partyForSearch.find((party) => {
              return party && parseInt(party.id) === parseInt(defaultPartyTypeId);
            })
          : null;

      if (deliveryType) {
        setTimeout(() => {
          handleDeliveryType(deliveryType, branchSelected);
        }, 50);
      }
      if (partyType) {
        setTimeout(() => {
          handleSelectedParty(partyType, deliveryType);
        }, 80);
      }
    }
  };

  // empty card 
  const emptyCardOnChange = (deliveryType = null, partyType = null) => {
    // cant empty card if card has item on edit
    if (order_id) {
      if (!buttonDisabled && cartItems && Object.keys(cartItems)?.length > 0 && !parseInt(getSystemSettings(generalSettings, "change_odt_edit"))) {
        toast.error("Please complete the current order");
        return
      }
      setOrderDetails((curr) => {
        const newData = {
          ...curr,
          orderTypeDetails: {
            orderTypeId: deliveryType ? deliveryType.id : null,
            orderTypeName: deliveryType ? deliveryType.name : "",
          },
          partyDetails: {
            partyId: partyType ? partyType.id : null,
            partyName: partyType ? partyType.name : "",
            partyPercent: partyType ? partyType.receivable_amount : "",
            partyRefNo: partyType ? partyType.show_ref_no : "",
            for_cc: partyType ? partyType.for_cc : 0,
          },
        }
        if(partyType){
          const fpParty = partyType && (partyType.name.match(/food(.*)panda/i));
          const isRefNo = partyType && partyType?.show_ref_no === 1;
      
          // Reset if previously Food Panda
          if (curr.newCustomerInfo.name === "Food Panda") {
            newData.newCustomerInfo = {
              ...newData.newCustomerInfo,
              name: "",
              phn_no: "",
              ref_no: ""
            };
          }
          
          // Apply Food Panda values if conditions match
          if (fpParty && isRefNo) {
            newData.newCustomerInfo = {
              ...newData.newCustomerInfo,
              name: "Food Panda",
              phn_no: "00000000000",
            };
          }
        }
        
        return newData;
      });
    } else {
      setOrderDetails((curr) => {
        const newData = {
          ...curr,
          orderTypeDetails: {
            orderTypeId: deliveryType ? deliveryType.id : null,
            orderTypeName: deliveryType ? deliveryType.name : "",
          },
          partyDetails: {
            partyId: partyType ? partyType.id : null,
            partyName: partyType ? partyType.name : "",
            partyPercent: partyType ? partyType.receivable_amount : "",
            partyRefNo: partyType ? partyType.show_ref_no : "",
            for_cc: partyType ? partyType.for_cc : 0,
          },
          note_to_rider: "",
          order_tip: 0,
          card_number: "",
          payment_discount: null,
          payment_dis_type: "",
          card_number_settle: "",
          token: null,
          unique_token: null,
          order_No: null,
          table: null,
          waiter: null,
          total_guest: 1,
          is_reservation: 0,
          table_id: null,
          table_name: null,
          serviceCharge: 0,
          discount: 0,
          scheme: {
            scheme_id: null,
            scheme_name: "",
            cap_amount: 0,
            min_order_amount: 0,
            discount_amount: 0,
            open_discount: null,
            discount_type: "",
            how_much_discount: null,
            discount_addon: "",
            discount_tax: 0,
          },
          pre_order_date: null,
          is_advance_booking: 0,
          is_edit: 0,
          pre_order_modal: false,
          advance_amount: 0,
          is_split: 0,
        }
        if(partyType){
          const fpParty = partyType && (partyType.name.match(/food(.*)panda/i));
          const isRefNo = partyType && partyType?.show_ref_no === 1;
      
          // Reset if previously Food Panda
          if (curr.newCustomerInfo.name === "Food Panda") {
            newData.newCustomerInfo = {
              ...newData.newCustomerInfo,
              name: "",
              phn_no: "",
              ref_no: ""
            };
          }
          
          // Apply Food Panda values if conditions match
          if (fpParty && isRefNo) {
            newData.newCustomerInfo = {
              ...newData.newCustomerInfo,
              name: "Food Panda",
              phn_no: "00000000000",
            };
          }
        }
        
        return newData;
      });
      setTheVat(0);
      setServiceCharges(0);
      setPaidMoney(0);
      if (Object.keys(cartItems)?.length) {
        setCartItems({});
      }
      if (showSettle) {
        setShowSettle(false);
      }
      setSelectTable({});
      setGuestSelected(1);
      setBogo(0);
      discountInput.current = true;
    }
    setSearchedFoodItem({
      searched: false,
      list: null,
    });
    setSearchInput("");
    if (inputSearch.current) inputSearch.current.value = "";
  }

  // const getTableWithStatus1 = () => {
  //   const pendingUrl = BASE_URL + "/settings/get-table-status";
  //   return axios
  //     .get(pendingUrl, {
  //       headers: { Authorization: `Bearer ${getCookie()}` },
  //     })
  //     .then((res) => {
  //       let tempTables = res.data.filter((eachTable) => {
  //         //let isReserved = !order_id ? eachTable.status === "0" : 1;
  //         return (
  //           !order_id &&
  //           parseInt(eachTable.branch_id) === orderDetails.branch.id &&
  //           eachTable.status === "0"
  //         );
  //       });
  //       setGetTable(tempTables);
  //     })
  //     .catch((err) => {});
  // };

  // set states on editorder
  function setStatesOnEditOrder(data) {
    // console.log("Editdata : ", data);

    const formatTime = data?.token?.time && moment(data.token.time).format('DD-MMM-YYYY hh:mm A');
    token_No.current = {
      id: data.token?.id,
      time: formatTime,
      order_id: order_id
    }

    const theBranch = branchForListSearch && branchForListSearch[data.branch.id];
    let time_to_deliver = null;
    if(!Number.isInteger(Number(data.time_to_deliver)) && data.time_to_deliver){
      time_to_deliver = new Date(data.time_to_deliver);
    }
    // add one extra field in formdata if card offer
    setOrderDetails((curr) => ({
      ...curr,
      branch: theBranch,
      discount: data.discount,
      card_number: data.card_number,
      payment_discount: null,
      payment_dis_type: "",
      card_number_settle: "",
      orderTypeDetails: data.orderTypeDetails,
      partyDetails: data.partyDetails,
      note_to_rider: orderDetails.note_to_rider,
      order_tip: 0,
      table: data?.table && data.table?.length !== 0 ? data.table : null,
      waiter: parseInt(authUserInfo?.details?.offline_enable) === 1 ? (data?.waiter_id ? {
        id: data.waiter_id,
        name: data.waiter_name,
      } : null) : data?.waiter.length !== 0 ? data?.waiter : null,
      dept_commission: data.dept_commission,
      payment_type: data.payment_type && data.payment_type?.length && typeof (data.payment_type) === "object" ? [{ ...data.payment_type, bill_amount: Number(data?.advance_payment) }] : null,
      payment_amount: data.payment_amount
        ? parseFloat(data.payment_amount)
        : data.payment_amount,
      total_guest: parseInt(data.total_guest),
      is_reservation: parseInt(data?.is_reservation),
      table_id: data?.table_id ? JSON.parse(data.table_id) : data?.table_id,
      table_name: data?.table_name,
      newCustomerInfo: {
        ...data.customerInfo,
        modal: false,
        order: null,
        is_confirm: true,
      },
      token: {
        ...data.token,
        order_id: order_id
      },
      unique_token: data.unique_token,
      serviceCharge: parseFloat(data.serviceCharge),
      service_amount: data.service_amount,
      discount_amount: data.discount_amount,
      scheme: data.scheme?.id !== null ? {
        ...data.scheme,
        cap_amount: parseFloat(data.scheme.cap_amount),
        min_order_amount: parseFloat(data.scheme?.min_order_amount ?? 0),
        discount_amount: parseFloat(data.scheme.discount_amount),
      } : (data.scheme || orderDetails.scheme),
      pre_order_modal: false,
      pre_order_date: time_to_deliver,
      advance_amount: Number(data?.advance_payment ?? 0),
      is_split: parseInt(data?.is_split ?? 0),
      is_advance_booking: parseInt(data.is_advance_booking),
      is_edit: data.online_order_edit,
    }));

    if (data.scheme && data.scheme.discount_type === "bogo" && data.scheme.discount_amount) {
      setBogo(parseFloat(data.scheme.discount_amount))
    }

    if (data.scheme?.open_discount) {
      discountInput.current = false;
    }

    setDeliveryCharges(data.serviceCharge);
    // const branch = branchForListSearch[data.branch.id];
    // const isWebOrder = parseInt(getSystemSettings(generalSettings, "online_order_edit")) === 1 &&
    //    data.partyDetails.partyName === "Website" && data.online_order_edit;
    // set data on cartItems
    // const items = setItemOnEdit(data, schemeForSearchObj, authUserInfo,
    //   getSystemSettings(generalSettings, "tax_type"),branch.branch_tax,isWebOrder);
    const items = setItemOnEdit(data,schemeForSearchObj,authUserInfo, roundOffPrice)
    setEditKot(items);
    setCartItems(items);

    if (history.location &&
      (history.location?.search === "?waiter=edit" ||
        history.location?.search?.startsWith("?table=") ||
        history.location?.search === "?table_merge=edit")
    ) {
      setModal10Show(true);
    }
    setButtonDisabled(false);
  }

  // //axios request for submit
  // const axiosForItemGroupByDept = (orderData) => {
  //   const pendingUrl = BASE_URL + "/settings/get-food-group-with-menu";
  //   return axios
  //     .get(pendingUrl, {
  //       headers: { Authorization: `Bearer ${getCookie()}` },
  //     })
  //     .then((res) => {
  //       // save data to local
  //       setAvailableFoodGroups(res.data);
  //       setDataToLocal(pendingUrl, res.data);

  //       if (order_id) {
  //         //set New Food Group Menu Wise
  //         //let tempFoodGroup = res.data[orderData.dept_tag.id];
  //         // setShowFilterFoodGroupsByDept(tempFoodGroup);

  //         // // setInitialFoodItem();
  //         handleFilterFoodGroup(orderData.dept_tag);
  //         //handleSetGroupAndItem(tempFoodGroup[0], orderData.dept_tag);
  //       }
  //     })
  //     .catch((err) => {
  //       if (offline(pendingUrl)) {
  //         let parseRes = getDataFromLocal(pendingUrl);
  //         setAvailableFoodGroups(parseRes);
  //       }
  //     });
  // };

  // const handleSetGroupAndItem = (groupItem, deptTag) => {
  //   let tempItems =
  //     foodForPOS &&
  //     foodForPOS.filter((tempItem) => {
  //       let $ifExits = tempItem.food_groups.includes(groupItem.id);
  //       let ifExits2 = tempItem.menu_ids.includes(
  //         deptTag ? deptTag.id : orderDetails?.dept_tag.id
  //       );
  //       if ($ifExits === true && ifExits2 === true) {
  //         return parseInt(groupItem.id) === groupItem.id;
  //       }
  //     });
  //   if (tempItems && tempItems.length > 0) {
  //     setFoodItem({
  //       ...foodItem,
  //       foodGroup: groupItem,
  //       items: tempItems,
  //       selectedItem: tempItems && tempItems[0],
  //       variations:
  //         tempItems && parseInt(tempItems[0].has_variation) === 1
  //           ? tempItems[0].variations
  //           : null,
  //       properties:
  //         tempItems && parseInt(tempItems[0].has_property) === 1
  //           ? tempItems[0].properties
  //           : null,
  //     });
  //   } else {
  //     setFoodItem({
  //       foodGroup: groupItem,
  //       items: null,
  //       selectedItem: null,
  //       variations: null,
  //       properties: null,
  //     });
  //   }
  // };

  //dynamic style
  const style = {
    logo: {
      backgroundColor:
        generalSettings &&
        getSystemSettings(generalSettings, "type_background"),
      backgroundImage:
        generalSettings &&
        `url(${getSystemSettings(generalSettings, "type_logo")})`,
    },
    currency: {
      backgroundColor:
        generalSettings && getSystemSettings(generalSettings, "type_clock"),
      color:
        generalSettings && getSystemSettings(generalSettings, "type_color"),
    },
  };

  useEffect(() => {
    let stockUnsubscribe;

    if (!generalSettings || !Object.keys(generalSettings)?.length) return;
    if (authUserInfo && (authUserInfo.details.user_type === "call_center") && parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1) {
      setModalOrderType(true);
    }
    if (parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 && (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager" || authUserInfo.details.user_type === "waiter")) {
      stockUnsubscribe = fetchStock();
    }

    setTaxType(getSystemSettings(generalSettings, "tax_type"));
    if (parseInt(getSystemSettings(generalSettings, "menu_wise_rate")) === 1) {
      menuWisePrice.current = 1
    }

    return () => {
      if (typeof stockUnsubscribe === "function") stockUnsubscribe();
    };

  }, [generalSettings]);

  // useEffect(() => {
  //   const interval = setInterval(() => {

  //     let api =  authUserInfo.details.user_type === "call_center"
  //                ? "/settings/new-callcenter-order"
  //                : "/settings/new-order";

  //     let url = BASE_URL + api;
  //     let pendingOrder = JSON.parse(localStorage.getItem("orderplaced"));
  //     if (navigator.onLine && pendingOrder && pendingOrder?.length > 0) {
  //       setLoading(true);
  //       syncLocalOrders(url);
  //     }
  //   }, 9000);
  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, []);

  // validate addon Qty //
  const handleEditOrder = (data) => {
    setButtonDisabled(true);
    const isOffline = parseInt(authUserInfo?.details?.offline_enable) === 1;
    const branchFull = branchForListSearch && branchForListSearch[data.branch.id];
    let workPeriod = data?.workPeriod;
    if (isOffline) {
      workPeriod = workPeriodListForBranch && workPeriodListForBranch.find((tempWorkPeriod) => {
        return (parseInt(data.work_period_id) === parseInt(tempWorkPeriod.id)) && tempWorkPeriod.ended_at === null;
      });
    }
    //set vat percent
    setNewSettings((curr)=>({
      ...curr,
      vat: branchFull?.branch_tax,
      workPeriod: workPeriod,
    }));
    handleSetBranchOnEdit(branchFull);
    setTheTax(branchFull?.branch_tax);
    setManagerId(data.manager_id);
    const ordertype = data.orderTypeDetails.orderTypeId;
    if (ordertype && orderTypeList) {
      const deliveryType = orderTypeList.data.find((delivery) => {
        return parseInt(delivery.id) === parseInt(ordertype) && delivery.status === "On";
      });
      setSelectedDeliveryType(deliveryType);
      if (deliveryType && (deliveryType.name.toLowerCase() === "delivery")) {
        const deliveryChargesLock = parseInt(getSystemSettings(generalSettings, "delivery_charges_lock")) === 0;
        if (deliveryChargesLock) {
          deliveryInput.current = false;
        }
      }
      setTimeout(() => {
        handleFilterScheme(branchFull, deliveryType);
      }, 20);
    }
    const partyId = data.partyDetails.partyId;
    if (partyId && partyForSearch) {
      const partyType = partyForSearch?.find((party) => {
        return parseInt(party.id) === parseInt(partyId);
      });
      partyType && setSelectedParty(partyType);
      if (partyType?.associate_with_payment_type !== null) {
        let tempAvailablePaymentType = paymentTypeForSearch &&
          paymentTypeForSearch.filter((paymentType) => {
            return JSON.parse(partyType?.associate_with_payment_type).includes(
              paymentType.id
            );
          });
        setPaymentTypeAvailable(tempAvailablePaymentType);
      }
      handleFilterDept(branchFull.id, partyType?.associate_with_menu)
    }
    const deptTagId = isOffline ? data.dept_tag_id : data.dept_tag?.id;
    if (deptTagId && deptTagForSearch) {
      const dept_tag = deptTagForSearch?.find((dept) => {
        return parseInt(dept.id) === parseInt(deptTagId);
      });
      dept_tag && handleDeptTag(dept_tag);
    }
  };

  const handleFilterDept = (branch_id = null, order_type = null, type = null) => {
    if (deptTagForSearch && branch_id) {
      let deptartmentTag;
      if (type && type === "order type" && branch_id) {
        deptartmentTag = deptTagForSearch?.filter((deptTag) => {
          return (
            JSON.parse(deptTag.branch_id).includes(branch_id) &&
            JSON.parse(deptTag.associate_with).includes(order_type)
          );
        });
      } else if (order_type && branch_id) {
        deptartmentTag = deptTagForSearch.filter((deptTag) => {
          return (
            JSON.parse(deptTag.branch_id).includes(branch_id) &&
            JSON.parse(order_type).includes(deptTag.id)
          );
        });
      } else if (branch_id) {
        deptartmentTag = deptTagForSearch.filter((deptTag) => {
          return (
            JSON.parse(deptTag.branch_id).includes(branch_id)
          );
        });
      }
      const deptartmentTag1 = deptartmentTag?.find(
        (deptTag) => deptTag.is_default_menu === 1
      );
      const finalDeptTag = deptartmentTag1 ? deptartmentTag1 : deptartmentTag[0];
      setAvailableDeptTags(deptartmentTag);
      !buttonDisabled && !order_id && handleDeptTag(finalDeptTag);
    } else {
      const deptartmentTag = deptTagForSearch && deptTagForSearch?.filter(
        (deptTag) => deptTag.is_default_menu === 1
      );
      deptartmentTag && setAvailableDeptTags(deptartmentTag);
      !buttonDisabled && !order_id && deptartmentTag && handleDeptTag(deptartmentTag[0])
    }
  }

  const checkSchemeOnEdit = (deliveryType)=>{
    const scheme = schemeForSearch.find((scheme) => {
      return (
        scheme.id === orderDetails.scheme?.scheme_id &&
        JSON.parse(scheme.order_type_id).includes(deliveryType.id) &&
        scheme.status == "1" &&
        scheme.scheme_type == "manual_apply"
      )
    })
    return scheme ? 1 : 0
  }

  const handleFilterScheme = (branch, deliveryType) => {
    setTempSchemeForSearch(
      schemeForSearch && schemeForSearch.length
        ? schemeForSearch.filter((scheme) => {
          return (
            JSON.parse(scheme.branch_id).includes(
              branch.id
            ) &&
            JSON.parse(scheme.order_type_id).includes(
              deliveryType.id
            ) &&
            scheme.status == "1" &&
            scheme.scheme_type == "manual_apply"
          );
        })
        : []
    );
  }

  const handleDeliveryType = (deliveryType, theBranch = null) => {
    // once delivery type is set, sets all the available dept tags which are associated with the delivery type
    // cant empty card if card has item on edit
    // if(order_id && deliveryType && orderDetails.scheme){
    //   if(!checkSchemeOnEdit(deliveryType)){
    //     toast.error("Can't change discount not found in od Type");
    //     return
    //   }
    // }
    if (
      deliveryType &&
      deliveryType.id &&
      (orderDetails?.branch || theBranch)
    ) {
      setSelectedDeliveryType(deliveryType)
      handleFilterDept((orderDetails.branch?.id ?? theBranch?.id), deliveryType.id, "order type")
      handleFilterScheme((orderDetails.branch ?? theBranch?.id), deliveryType)
    } else if (parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1 && deliveryType) {
      setSelectedDeliveryType(deliveryType)
    }

    // when delivery type is changed(if selectedParty exists, it does after delivery type is set), sets party to null
    if (deliveryType && selectedParty) setSelectedParty(null);
    const deliveryChargesLock = parseInt(getSystemSettings(generalSettings, "delivery_charges_lock")) === 0;
    let deliveryCharge = parseFloat(getSystemSettings(generalSettings, "delivery_charges"));
    // set delivery charges if applicable
    if (authUserInfo && (authUserInfo.details.user_type === "call_center") && parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1) {
      setZoneArea(null);
      setArea(null);
      setDeliveryCharges(0);
    } else {
      if (deliveryType && (deliveryType.name.toLowerCase() === "delivery")) {
        if (deliveryChargesLock) {
          deliveryInput.current = false;
          setDeliveryCharges(deliveryCharge);
        } else {
          deliveryInput.current = true;
          setDeliveryCharges(deliveryCharge);
        }
      } else {
        deliveryInput.current = true;
        setDeliveryCharges(0);
      }
    }
    emptyCardOnChange(deliveryType)
    if (deliveryType && deliveryType.name.match(/dine(.*)in/i)) {
      getWaiter();
      getTable();
    }
  }

  const handleSelectedParty = (selectParty, deliveryType = null, selectParentOrderType = false) => {
    if (selectParty) {
      setSelectedParty(selectParty);
      if (selectParty?.associate_with_payment_type !== null) {
        let tempAvailablePaymentType = paymentTypeForSearch &&
          paymentTypeForSearch.filter((paymentType) => {
            return JSON.parse(selectParty?.associate_with_payment_type).includes(
              paymentType.id
            );
          });
        setPaymentTypeAvailable(tempAvailablePaymentType);
      }
      if(!order_id){
        handleFilterDept(orderDetails.branch?.id, selectParty?.associate_with_menu)
      }
      // cant empty card if card has item on edit
      emptyCardOnChange(deliveryType, selectParty);

      if(!order_id){
        // open table pop auto if dine in
        if (deliveryType && deliveryType.name.match(/dine(.*)in/i) && !order_id &&
          (parseInt(orderDetails.branch?.table_waiter) || parseInt(getSystemSettings(generalSettings, "table_waiter")) === 1)) {
          !selectParentOrderType && setModal10Show(true);
        } else if (selectParty && deliveryType && parseInt(JSON.parse(getSystemSettings(generalSettings, "customer_validation"))[deliveryType.name]) === 1 && (deliveryType.name.toLowerCase() === "delivery") &&
          !order_id && (parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1 ? (authUserInfo.details.user_type !== "call_center") : true)) {
            !selectParentOrderType && setModal9Show(true)
        }
      }
    }
  }

  // useEffect(() => {
  //   // parses and sets the menu when all food items are available
  //   if (foodForPOS && foodForPOS.length) {
  //     setMenu(parseFoodItems(foodForPOS));
  //   }
  // }, [foodForPOS]);

  const checkFoodGroupScheduling = (foodGroup, msg= true)=>{
    // If scheduling is OFF, allow it
    if (!foodGroup?.is_schedule || !foodGroup.food_schedules) {
      return true;
    }
    const day = moment(new Date()).format("dddd");
  
    const findDay = foodGroup.food_schedules.find(item => item.day_name === day);
  
    // If day not scheduled or schedule OFF, allow it
    if (!findDay || !findDay.is_schedule) {
      return true;
    }
  
    // inclusive check []
    if (!checkBetweenTime(findDay.from_time,findDay.to_time)) {
      if(msg){
        toast.error(`${foodGroup.name} unavailable right now.`, { ...toastObj, toastId: `unavailable-${foodGroup.id}` });
      }
      return false;
    }
  
    return true;
  }

  const handleFoodGroup = (foodGroup) => {
    if(!checkFoodGroupScheduling(foodGroup)) return;
    setActiveFoodGroup(foodGroup.id);
    setSearchedFoodItem({
      searched: false,
      list: null,
    });
    setSearchInput("");
  };

  //set food group and menu
  const handleDeptTag = (deptTag) => {
    if (!deptTag || !deptTag.id) return;
    
    setSelectedDeptTag(deptTag)
    if (Object.keys(availableFoodGroups)?.length && availableFoodGroups[deptTag?.id] ) {
      const firstUnavailableGroup = availableFoodGroups[deptTag.id].find(group => checkFoodGroupScheduling(group, false));
      setActiveFoodGroup(firstUnavailableGroup?.id);
    }
    // cant empty card if card has item on edit
    emptyCardOnChange()
  }

  const customerScreenOrder = async (tax, total) => {
    let orders = {
      newOrder: null,
      subtotal: 0,
      discount: 0,
      order_tip: 0,
      type: null,
      tax: 0,
      service_charge: 0,
      totalAmount: 0,
      timestamp: Date.now()
    }
    if ((newOrder && newOrder?.length) || total) {
      let order = null;
      if (newOrder && newOrder?.length) {
        order = newOrder.map((item) => {
          let properties = item.properties;
          if (item.properties?.length) {
            properties = item.properties.map((property) => ({
              ...property,
              item: {
                name: property.item.name
              }
            }))
          }
          return {
            after_tax_price: item.after_tax_price,
            quantity: item.quantity,
            seq: item.seq,
            item: {
              name: item.item.name,
              has_property: item.item.has_property,
              has_variation: item.item.has_variation,
            },
            ...(item.item.has_variation === "1" && { variation: item.variation }),
            ...(item.item.has_property === "1" && { properties: properties }),
          }
        });
      }
      orders = {
        newOrder: order,
        subtotal: cartSubTotal,
        discount: orderDetails.scheme?.discount_amount,
        tax: tax,
        totalAmount: total,
      }
    }
    if (orderDetails.branch && orderDetails.branch?.customer_screen_real_time) {
      await handleCustomerOrderUpdate(orders);
    } else {
      try {
        localStorage.setItem("order_update", JSON.stringify(orders));
      } catch (err) {
        console.error("localStorage error:", err);
      }
    }
  }

  const orderUpdate = async () => {
    if (parseInt(getSystemSettings(generalSettings, "customer_screen_enable")) === 1) {
      const total = totalsettle ? totalsettle : cartTotal;
      const tax = theVatSettle ? theVatSettle : theVat;
      await customerScreenOrder(tax, total);
    }
  }

  useEffect(() => {
    orderUpdate();
  }, [
    theVatSettle,
    totalsettle,
  ])

  useEffect(() => {
    // cal tax subtotal and total
    let serviceCharge = 0;
    let isServiceCharge = orderDetails?.branch && orderDetails.branch?.service_fees &&
      orderDetails?.total_guest >= orderDetails.branch.service_fees_person && selectedDeliveryType && selectedDeliveryType.name.match(/dine(.*)in/i)
    if (isServiceCharge) {
      let subtotalTax = Number(cartSubTotal) + Number(theVat);
      if (parseInt(getSystemSettings(generalSettings, "service_charges_type")) === 1) {
        subtotalTax = Number(roundOffPrice(subtotalTax - Number(orderDetails.scheme.discount_amount)));
      }
      serviceCharge = getServiceCharges(
        subtotalTax,
        orderDetails.branch.service_fees
      );
    }
    setServiceCharges(roundOffPrice(serviceCharge));
    const delivery = deliveryCharges ? parseFloat(deliveryCharges) : 0;

    const subTotalVat = parseFloat(cartSubTotal) + parseFloat(theVat);
    const carttotal = subTotalVat + delivery + parseFloat(serviceCharge) - Number(orderDetails.scheme?.discount_amount || 0) - Number(orderDetails.advance_amount || 0);

    setCartTotal(roundOffPrice(carttotal));
    // subtTotal + vat
    //getTaxedTotal(calculateSubTotal(cartItems), theTax, taxType)
    if (authUserInfo.details.user_type === "call_center" && parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1) {
      if (zoneArea && zoneArea?.min_for_free_delivery > 0 && (carttotal - delivery) >= zoneArea?.min_for_free_delivery) {
        setDeliveryCharges(0)
      } else if (zoneArea && zoneArea.free_delivery === 0 && deliveryCharges == 0 && zoneArea.fee > 0) {
        setDeliveryCharges(zoneArea.fee)
      }
    }
    const customerOrder = async () => {
      if (parseInt(getSystemSettings(generalSettings, "customer_screen_enable")) === 1) {
        await customerScreenOrder(theVat, roundOffPrice(carttotal))
      }
    }
    customerOrder()
  }, [
    cartSubTotal,
    theVat,
    orderDetails?.total_guest,
    orderDetails.scheme?.discount_amount,
    orderDetails.advance_amount,
    deliveryCharges,
  ]);

  //item add/delete animate
  const Cartanimation = (id) => {
    let blink = cardAnimate.current[id];
    if (animate.current === true && blink) {
      const parentPos = flyStart.current?.getBoundingClientRect();
      const elementImage = imageAnimate.current;
      const childPos = blink?.getBoundingClientRect();
      if (childPos && parentPos) {
        const childY = childPos.top > 410 ? 410 : childPos.top;
        const distanceX = (childPos.left) - parentPos.left;
        const distanceY = (childY - 7) - parentPos.top;
        const virtualDiv = document.createElement('div');
        virtualDiv.style.position = 'absolute';
        virtualDiv.style.top = `${parentPos.top}px`;
        virtualDiv.style.left = `${parentPos.left}px`;
        virtualDiv.style.width = `${parentPos.width}px`;
        virtualDiv.style.height = `${parentPos.height}px`;
        const image = new Image();
        image.src = elementImage; // Replace with the path to your image
        image.style.height = '3rem';
        image.style.borderRadius = '50%';
        virtualDiv.appendChild(image);
        document.body.appendChild(virtualDiv);
        gsap.to(virtualDiv, {
          motionPath: {
            path: [
              { x: 0, y: 0 },
              { x: -35, y: -30 },
              { x: `${distanceX}px`, y: `${distanceY}px` },
            ],
            curviness: 1.5,
          },
          duration: .7,
        });
        setTimeout(() => {
          blink?.classList && blink.classList.add("blink");
        }, 200);

        // gsap.to(virtualDiv, { x: distanceX, y: distanceY, duration: .8 });
        setTimeout(() => {
          blink?.classList && blink.classList.remove("blink");
          document.body.removeChild(virtualDiv);
          gsap.set(flyStart.current, { x: 0, y: 0 });
        }, 600);
      }
    } else {
      if (animate.current == "add") {
        blink?.classList && blink.classList.add("blink");
      } else if (animate.current == "del") {
        blink?.classList && blink.classList.add("delBlink");
      }
      setTimeout(() => {
        if (animate.current == "add") {
          blink.classList.remove("blink");
        } else if (animate.current == "del") {
          blink.classList.remove("delBlink");
        }
      }, 350);
    }
  }

  //cal dis total 
  const calculateDiscount = (cartItem) => {
    let itemDiscount = Object.values(cartItem).reduce(
      (total, item) => item.item_discount + total,
      0
    );
    if (orderDetails.scheme?.cap_amount && orderDetails.scheme.cap_amount > 0 && orderDetails.scheme.cap_amount < itemDiscount) {
      itemDiscount = orderDetails.scheme.cap_amount;
    }
    const discountPercent = orderDetails.scheme?.how_much_discount;

    if (!orderDetails.scheme.open_discount) {
      itemDiscount = roundOffPrice(itemDiscount);
    }
    setOrderDetails((curr) => {
      const newData = {
        ...curr,
        discount: curr.scheme && discountPercent ? (curr.scheme.discount_type?.toLowerCase() === "fixed")
          ? 0 : discountPercent
          : curr.discount,
        scheme: {
          ...curr.scheme,
          discount_amount: curr.scheme.open_discount ? curr.scheme.discount_amount : itemDiscount,
        },
      }
      return newData;
    });
    return parseFloat(itemDiscount);
  }

  const calculateTax = (subtotal, dis) => {
    const taxSubtotal = checkTaxType(subtotal, dis);
    const roundedTax = getTax(theTax, taxSubtotal);
    setTheVat(roundOffPrice(roundedTax));
    return roundedTax
  }

  const removeMinOdrScheme = (subtotal) =>{
    setOrderDetails((curr) => ({
      ...curr,
      scheme: {
        ...curr.scheme,
        discount_amount: 0,
      }
    }))
    calculateTax(subtotal, 0);
  }

  useEffect(() => {
    // whenever cart items change, update all cart totals
    let dis = 0;
    if (!Object.keys(cartItems).length) {
      setCartSubTotal(0);
      setCartTotal(0);
      setTheVat(0);
      setOrderDetails((curr) => ({
        ...orderDetails,
        scheme: {
          ...curr.scheme,
          discount_amount: 0,
        }
      }))
    } else {
      const total = calculateSubTotal(cartItems);
      let subtotal = getBeforeTaxPrice(total);
      dis = calculateDiscount(cartItems);

      setCartSubTotal(roundOffPrice(subtotal));

      if (orderDetails.scheme.open_discount && orderDetails.scheme.how_much_discount) {
        hanldeDiscountPercent(subtotal, orderDetails.scheme.how_much_discount)
      } else {
        const minOrderAmount = Number(orderDetails.scheme?.min_order_amount ?? 0);
        if (minOrderAmount > 0 && (subtotal < minOrderAmount)) {
          removeMinOdrScheme(subtotal);
        }else{
          calculateTax(subtotal, dis);
        }
      }

    }

    //order items set
    const orderItem = [];
    let finalItem = {};
    for (const itemHash in cartItems) {
      const originalItem = cartItems[itemHash];
      const item = JSON.parse(JSON.stringify(originalItem));
      if (parseInt(authUserInfo?.details?.offline_enable) === 1) {
        // Destructure and exclude `property` and `variation` from `item.item`
        const { variations, properties, variation_recipe, property_groups_validation, food_group_status, slug, image, group_qty, sku, food_group_name, menu_ids, kot_branch_id, ...updatedItem } = item.item;

        // Update the original object
        item.item = updatedItem;
      }
      // parse properties for 'new order' state
      const pickedProperty = [];
      if (item.hasOwnProperty("properties") && item.properties) {
        const items =
          item.properties[
          Object.values(item.properties).forEach((itm) => {
            for (const key in itm) {
              pickedProperty.push({
                item: itm[key].item,
                quantity: itm[key].quantity,
                group_qty: itm[key].group_qty,
              });
            }
          })
          ];
      }

      if (order_id) {
        const kot = editKot && editKot[itemHash];
        // for (const key in editKot) {
        const isKotItem = (!item.new && kot && item.item.has_property === kot.item.has_property &&
          item.item.has_variation === kot.item.has_variation);
        if (
          isKotItem && item.quantity > kot.quantity
        ) {
          finalItem = {
            ...finalItem,
            [itemHash]: {
              ...item,
              quantity: item.quantity - kot.quantity,
              print_status: "added",
              properties: pickedProperty ? pickedProperty : null,
            },
          };
        } else if (
          isKotItem && item.quantity === kot.quantity
        ) {
          setDeletedItemsOnEdit((curr) => {
            const { [itemHash]: _, ...rest } = curr
            return rest
          });
        }
      }

      // discount
      // dis += parseFloat(item.item_discount);
      // for bogo offers

      if (
        (bogo === 0 && item.discount_type === "bogo" && (parseInt(orderDetails.scheme.discount_amount) === 0 || parseInt(dis) === 0))
      ) {
        if ((order_id && item.offer_type === "bogo") || !order_id) {
          setBogo(roundOffPrice(getBeforeTaxPrice(calculatePriceForCartVariation(item, 1))));
          setCartItems((curr) => {
            const newData = {
              ...curr,
              [itemHash]: {
                ...item,
                offer_type: order_id && item.offer_type === "bogo" ? "bogo" : !order_id && "bogo",
              },
            };
            return newData;
          });
        } else {
          orderItem.push({
            ...item,
            quantity: (parseInt(getSystemSettings(generalSettings, "open_qty_box")) === 1) ? (item.quantity) : item.quantity,
            properties: pickedProperty,
            print_status: "new",
            ...((item.offer_type === "bogo" && { offer_type: "bogo", }))
          });
        }
      } else {
        orderItem.push({
          ...item,
          quantity: (parseInt(getSystemSettings(generalSettings, "open_qty_box")) === 1) ? item.quantity : item.quantity,
          properties: pickedProperty,
          print_status: "new",
          ...((item.offer_type === "bogo" && { offer_type: "bogo", }))
        });
      }
    }
    setItemAdd(finalItem);
    setNewOrder(orderItem);

  }, [cartItems]);

  //switcher for call center payment
  const handlePaymentType = (payment_type) => {
    setCallCenterPayment({
      transaction_no: payment_type === "Online" ? callCenterPayment.transaction_no : "",
      payment_type,
      transactionModal: payment_type === "Online",
    });
  };

  // HELPERS
  const handleCloseItemModal = () => {
    //setTempQty(0);
    setShowModal(false);
    // setSelectGroup({});
  };
  const handleShowItemModal = () => setShowModal(true);

  const handleFoodItem = (foodItem) => {
    // check if item has properties or variations
    const keyExists = foodItem?.menu_variation?.hasOwnProperty(selectedDeptTag.id);
    const result = keyExists
      ? String(foodItem.menu_variation[selectedDeptTag.id]) === "1"
      : foodItem.has_variation === "1";

    if (foodItem.has_property === "1" || (menuWisePrice.current ? result : foodItem.has_variation === "1")) {
      setSelectedFoodItemId(foodItem.id);
      let foodItm = {
        ...foodItem,
        has_variation: menuWisePrice.current ? (String(foodItem?.menu_variation?.[selectedDeptTag.id] ?? foodItem.has_variation)) : foodItem.has_variation,
        price: menuWisePrice.current && foodItem.has_variation === "0" ? foodItem.price[selectedDeptTag.id] : foodItem.price,
        variations: menuWisePrice.current && foodItem.has_variation === "1" ? (foodItem.variations[selectedDeptTag.id]?.length ? [...foodItem.variations[selectedDeptTag.id]].sort((a, b) => a?.variation_sorting - b?.variation_sorting) : foodItem.variations[selectedDeptTag.id])
          : (foodItem.variations?.length ? [...foodItem.variations].sort((a, b) => a?.variation_sorting - b?.variation_sorting) : foodItem.variations),
      }
      setSelectedFoodItem({ item: foodItm });
      (foodItm.properties || (foodItm.variations && foodItm.variations[0])) &&
        handleShowItemModal();
    } else {
      // quickAddToCart
      let foodItm = {
        ...foodItem,
        has_variation: menuWisePrice.current ? (String(foodItem?.menu_variation?.[selectedDeptTag.id] ?? foodItem.has_variation)) : foodItem.has_variation,
        price: menuWisePrice.current ? foodItem.price[selectedDeptTag.id] : foodItem.price
      }
      addToCart(foodItem.id, { item: foodItm });
    }
  }

  const handleFoodItemClicked = (foodItem, e, isfirst = false) => {
    animate.current = true;
    flyStart.current = e.target;
    imageAnimate.current = foodItem.image;
    if (validateIfCanAddToCart(isfirst)) return;
    const tableValidation = selectedDeliveryType && selectedDeliveryType.name.match(/dine(.*)in/i) &&
      (parseInt(orderDetails.branch?.table_waiter) || parseInt(getSystemSettings(generalSettings, "table_waiter")) === 1);
    const customerValidation = order_id || (orderDetails.newCustomerInfo.ref_no?.length && orderDetails.newCustomerInfo.ref_no?.length >= selectedParty.ref_min &&
      orderDetails.newCustomerInfo.ref_no?.length <= selectedParty.ref_max && orderDetails.newCustomerInfo.is_confirm);
    const customerDeliveryValidation = (orderDetails.newCustomerInfo?.name !== "" && orderDetails.newCustomerInfo.phn_no !== "") && orderDetails.newCustomerInfo.is_confirm;
    // if del is food panda then show customer popup
    const tableSelected = Boolean(orderDetails.table);
    const waiterOd = getSystemSettings(generalSettings, "waiter_order_type") ? JSON.parse(getSystemSettings(generalSettings, "waiter_order_type")) : null;
    const checkCallCenter = orderDetails.newCustomerInfo?.name !== "" && orderDetails.newCustomerInfo.is_confirm;
    const shouldShowCustomerModal = (authUserInfo.details.user_type === "call_center" && !checkCallCenter) ||
      (parseInt(JSON.parse(getSystemSettings(generalSettings, "customer_validation"))[selectedDeliveryType.name]) === 1 && !customerDeliveryValidation) ||
      (selectedParty && parseInt(selectedParty.show_ref_no) === 1 && !customerValidation);

    // check table waiter or customer id required
    if (tableValidation && !tableSelected) {
      getTable();
      setModal10Show(true);
    } else if (waiterOd && waiterOd.length && (waiterOd.includes(selectedDeliveryType.id) && !orderDetails.waiter)) {
      setModal10Show(true);
    } else if (shouldShowCustomerModal) {
      setModal9Show(true);
    } else {
      handleFoodItem(foodItem)
    }

  };

  // check offer validation
  const checkOfferValidation = (scheme, item) => {
    if (scheme.item_type === "Group") {
      const foodGroupMatch = !JSON.parse(scheme.groups_id).some((element) => item.item.food_groups.includes(element))
      if (scheme.menu_id && scheme.menu_id !== "" && scheme.menu_id !== "0") {
        //if (!JSON.parse(scheme.groups_id).includes(item.item.food_groups[0]))
        if (foodGroupMatch || (parseInt(scheme.menu_id) !== selectedDeptTag.id)) {
          return false;
        }
      } else if (foodGroupMatch) {
        return false
      }
      return true
    } else if (scheme.item_type === "Item") {
      const foodItemMatch = !JSON.parse(scheme.items_id).includes(item.item.id)
      if (scheme.menu_id && scheme.menu_id !== "0" && scheme.menu_id !== "") {
        if (foodItemMatch || (parseInt(scheme.menu_id) !== selectedDeptTag.id)) {
          return false;
        }
      } else if (foodItemMatch) {
        return false;
      }
      return true;
    }
  }

  // check if any offer is on the item/ group
  const checkScheme = (item) => {

    if (orderDetails.scheme?.scheme_id) {
      if (!orderDetails.scheme?.open_discount) {
        const schemeToApply = schemeForSearchObj[parseInt(orderDetails.scheme.scheme_id)];
        const valid = checkOfferValidation(schemeToApply, item);
        if (!valid) {
          return false;
        }
        return schemeToApply;
      }
    } else {
      const schemeToApply = schemeForSearch.find((scheme) => {
        if (!JSON.parse(scheme.branch_id).includes(orderDetails.branch.id)) return false;
        if (!JSON.parse(scheme.order_type_id).includes(selectedDeliveryType.id)) return false;
        if (scheme.status !== "1") return false;
        if (scheme.scheme_type !== "enable_by_default") return false;
        const valid = checkOfferValidation(scheme, item);
        if (!valid) {
          return false;
        }
        const currDate = moment(new Date());
        const startDate = moment(scheme.start_date).format("LLL");
        const endDate = moment(scheme.end_date).format("LLL");
        const day = moment(currDate).format("ddd");

        // Specify the time format when parsing
        const scheduling = JSON.parse(scheme.schedule);
        if (!currDate.isBetween(startDate, endDate)) {
          return false;
        } else if (scheduling && scheduling?.length > 0 && !scheduling.includes(day)) {
          return false;
        } else if (scheme.time_schedule == 1 && !checkBetweenTime(scheme.from_time,scheme.to_time)) {
          return false;
        }
        
        // if (!currDate.isBetween(startDate, endDate)) return false;
        return true;
      });
      return schemeToApply;
    }
  };
  // party and order type validity 
  const validateIfCanAddToCart = (isfirst = false) => {
    let error = "";
    if (!selectedParty || !selectedParty.id) error = "party";
    if (!selectedDeliveryType || !selectedDeliveryType.id)
      error = "delivery type";
    if (error) {
      setShowordertypeModal(true)
      isfirst != "is-first" && toast.error(`Please select ${error} first.`);
    }

    return Boolean(error);
  };

  // new item added ot delete
  const handleNewItem = (item, id, hashId, edit) => {
    // if(order_id && !item?.after_tax_price){
    //   hashId += `-${newOrder?.length + 1}`
    // }
    let cartId = hashId;
    const checkStock = order_id ? ((cartItems?.[hashId] && cartItems[hashId]?.item?.stock_qty) ?? item.item.stock_qty) : item.item.stock_qty;
    if ((selectedParty?.name.toLowerCase() !== "pre order") && parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 && !item.item?.is_recipe && item.item?.is_deal === 0 && cartItems && cartItems[hashId]?.quantity >= checkStock) {
      toast.error("Stock limit has been exceed", { ...toastObj, toastId: "stock-limit-exceed" });
      return false
    }

    let schemeToApply = checkScheme(item);
    if (schemeToApply?.card_required || schemeToApply?.voucher_required) {
      schemeToApply = {
        ...schemeToApply,
        how_much_discount: orderDetails.scheme.how_much_discount
      }
    }

    //check bogo offer cart edit
    if (item.item_discount === 0 && item?.offer_type === "bogo" && edit && bogo > 0 && roundOffPrice(getBeforeTaxPrice(calculatePriceForCartVariation(item, 1))) < orderDetails.scheme.discount_amount) {
      toast.error("You can't select less price item than bogo discount", { ...toastObj, toastId: "bogo-price-error-1" });
      return false;
    }
    if (item.item_discount > 0 && item?.offer_type === "bogo" && edit && bogo > 0 && roundOffPrice(getBeforeTaxPrice(calculatePriceForCartVariation(item, 1))) > bogo) {
      toast.error("You can't select less price item than bogo discount", { ...toastObj, toastId: "bogo-price-error-2" });
      return false;
    }
    // set bogo price if edit
    if (item?.offer_type === "bogo" && item.item_discount === 0 && edit) {
      setBogo(roundOffPrice(getBeforeTaxPrice(calculatePriceForCartVariation(item, 1))));
    }

    if (
      bogo > 0 && orderDetails.scheme.discount_type === "bogo" &&
      parseInt(orderDetails.scheme.discount_amount) === 0 && !edit && !item?.item_discount
    ) {
      const afterTaxPrice = roundOffPrice(getBeforeTaxPrice(calculatePriceForCartItem(item, 1)));
      if (afterTaxPrice > bogo) {
        toast.error("You can't select item more than bogo price");
        return false
      } else {
        cartId = hashId + "x";
        setCartItems((curr) => {
          const newData = {
            ...curr,
            [hashId + "x"]: {
              ...item,
              quantity: 1,
              after_tax_price: afterTaxPrice,
              item_discount: afterTaxPrice,
              discount_type: schemeToApply
                ? schemeToApply.discount_type
                : "",
              scheme_id: schemeToApply ? schemeToApply.id : "",
              offer_type: "bogo",
              comments: "",
              image: "",
              seq: Object.keys(cartItems)?.length + 1,
              new: order_id ? true : false,
              is_ready: 0,
              discount: schemeToApply
                ? parseFloat(schemeToApply.how_much_discount)
                : 0,
            },
          };
          return newData;
        });
        setTimeout(() => {
          Cartanimation(cartId)
        }, 0);
        setShowModal(false);
        return false;
      }
    }

    if (cartItems[hashId]) {

      // add cart item already exist
      setCartItems((curr) => {
        const currQuantity = (edit && hashId !== id) ? (item.quantity + curr[hashId].quantity) : (edit ? (item.quantity) : (curr[hashId].quantity + 1));
        // const currQuantity = curr[hashId].quantity + 1;
        const currItem = (edit && hashId !== id) ? curr[hashId] : edit ? item : curr[hashId];
        const afterTaxPrice = roundOffPrice(getBeforeTaxPrice(calculatePriceForCartItem(currItem, currQuantity)));

        let schemePrice = schemeToApply?.discount_addon === "discount_without_addon" ? getBeforeTaxPrice(calculatePriceForCartVariation(currItem, currQuantity)) : afterTaxPrice;
        if (schemeToApply?.discount_tax) {
          schemePrice += roundOffPrice(getTaxPrice(afterTaxPrice, orderDetails?.payment_discount || theTax))
        }
        let disItemQty = currQuantity;
        if(schemeToApply?.qty){
          disItemQty = parseInt(currQuantity / schemeToApply.qty)
          schemePrice = disItemQty ? ((schemePrice / currQuantity) * disItemQty) : 0;
        }
        const itemDiscount = roundOffPrice(getItemDiscount(
          schemePrice,
          curr[hashId],
          disItemQty
        ));

        item.after_tax_price = afterTaxPrice;
        item.item_discount = itemDiscount;
        const newData = {
          ...curr,
          [hashId]: {
            ...curr[hashId],
            quantity: currQuantity,
            after_tax_price: afterTaxPrice,
            item_discount: bogo !== 0 && orderDetails.scheme.discount_type === "bogo"
              ? (curr[hashId]?.item_discount
                ? curr[hashId].item_discount
                : 0)
              : (itemDiscount),
            discount_type: schemeToApply
              ? schemeToApply.discount_type
              : (curr[hashId].discount_type ?? ""),
            scheme_id: schemeToApply ? schemeToApply.id : "",
          },
        };
        if (edit) newData[id] = item;
        if (edit && hashId != id) delete newData[id];
        return newData;
      });

    } else {
      //new cart item

      const afterTaxPrice = parseFloat(getBeforeTaxPrice(calculatePriceForCartItem(item, 1)).toFixed(2));

      let schemePrice = schemeToApply?.discount_addon === "discount_without_addon" ? getBeforeTaxPrice(calculatePriceForCartVariation(item, 1)) : afterTaxPrice;
      if (schemeToApply?.discount_tax) {
        schemePrice += roundOffPrice(getTaxPrice(afterTaxPrice, orderDetails?.payment_discount || theTax))
      }
      let disItemQty = 1;
      if(schemeToApply?.qty){
        disItemQty = parseInt(1 / schemeToApply.qty)
        schemePrice = disItemQty ? ((schemePrice / 1 ) * disItemQty) : 0;
      }
      
      if (
        bogo > 0 && orderDetails.scheme.discount_type === "bogo" &&
        parseInt(orderDetails.scheme.discount_amount) === 0
      ) {
        if (afterTaxPrice > bogo) {
          toast.error("You can't select item more than bogo price");
        } else {
          setCartItems((curr) => {
            const newData = {
              ...curr,
              [hashId + "x"]: {
                ...item,
                quantity: 1,
                after_tax_price: afterTaxPrice,
                new: order_id ? true : false,
                is_ready: 0,
                discount: schemeToApply
                  ? parseFloat(schemeToApply.how_much_discount)
                  : 0,
                item_discount: afterTaxPrice,
                discount_type: schemeToApply
                  ? schemeToApply.discount_type
                  : "",
                comments: "",
                image: "",
                scheme_id: schemeToApply ? schemeToApply.id : "",
                offer_type: "bogo",
                seq: Object.keys(cartItems)?.length + 1,
              },
            };
            if (edit) delete newData[id];
            return newData;
          });
        }
      } else {
        setCartItems((curr) => {
          const newData = {
            ...curr,
            [hashId]: {
              ...item,
              quantity: 1,
              after_tax_price: afterTaxPrice,
              new: order_id ? true : false,
              is_ready: 0,
              discount: schemeToApply
                ? parseFloat(schemeToApply.how_much_discount)
                : 0,
              item_discount: bogo !== 0 && orderDetails.scheme.discount_type === "bogo"
                ? (curr[hashId]?.item_discount
                  ? curr[hashId].item_discount
                  : 0)
                : (schemeToApply
                  ? roundOffPrice(getInitialItemDiscount(schemePrice, schemeToApply))
                  : 0),
              discount_type: schemeToApply
                ? schemeToApply.discount_type
                : "",
              comments: "",
              image: "",
              scheme_id: schemeToApply ? schemeToApply.id : "",
              seq: Object.keys(cartItems)?.length + 1,
            },
          };
          if (edit) delete newData[id];
          return newData;
        });
      }
    }
    setTimeout(() => {
      Cartanimation(cartId)
    }, 0);
  }

  // new item added or delete
  const handleSetItemQty = (item, id, qty) => {
    animate.current = "";
    const hashId = id;
    if ((selectedParty?.name.toLowerCase() !== "pre order") && qty > 0 && parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 && !item.item?.is_recipe && item.item?.is_deal === 0 && cartItems && (cartItems[hashId] && qty > item.item.stock_qty)) {
      toast.error("Stock limit has been exceed", toastObj);
      return false
    }
    if (cartItems[hashId] && qty > 0) {
      let schemeToApply = checkScheme(item);
      // add cart item already exist
      setCartItems((curr) => {
        const afterTaxPrice = roundOffPrice(getBeforeTaxPrice(calculatePriceForCartItem(curr[hashId], qty)));
        let schemePrice = schemeToApply?.discount_addon === "discount_without_addon" ? getBeforeTaxPrice(calculatePriceForCartVariation(curr[hashId], qty)) : afterTaxPrice;
        if (schemeToApply?.discount_tax) {
          schemePrice += roundOffPrice(getTaxPrice(afterTaxPrice, orderDetails?.payment_discount || theTax))
        }
        let disItemQty = qty;
        if(schemeToApply?.qty){
          disItemQty = parseInt(qty / schemeToApply.qty)
          schemePrice = disItemQty ? ((schemePrice / qty) * disItemQty) : 0;
        }

        const currItem = {
          ...curr[hashId],
          after_tax_price: afterTaxPrice,
          item_discount: bogo !== 0 && orderDetails.scheme.discount_type === "bogo"
            ? curr[hashId]?.item_discount
              ? curr[hashId].item_discount
              : 0
            : roundOffPrice(getItemDiscount(
                schemePrice,
                curr[hashId],
                disItemQty
              )),
        }

        const newData = {
          ...curr,
          [hashId]: {
            ...currItem,
            quantity: qty,
            discount_type: schemeToApply
              ? schemeToApply.discount_type
              : (currItem?.discount_type ?? ""),
            scheme_id: schemeToApply ? schemeToApply.id : "",
          },
        };
        return newData;
      });
    }
  }

  // new item added or delete
  const handleSetItemPrice = (item, id, price) => {
    animate.current = "";
    const hashId = id;
    const newPrice = Number(price);
    const qty = newPrice ? Number((newPrice / Number(item.item.price)).toFixed(2)) : 0;
    if(newPrice <= 0){
      toast.error("Price cannot be less than or equal to zero", toastObj);
      return
    }
    if(qty <= 0.1){
      toast.error("Qty cannot be less 0.1", toastObj);
      return
    }
    if ((selectedParty?.name.toLowerCase() !== "pre order") && qty > 0 && parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 && !item.item?.is_recipe && item.item?.is_deal === 0 && cartItems && (cartItems[hashId] && qty > item.item.stock_qty)) {
      toast.error("Stock limit has been exceed", toastObj);
      return
    }
    if (cartItems[hashId] && qty >= 0) {
      let schemeToApply = checkScheme(item);
      // add cart item already exist
      setCartItems((curr) => {
        const afterTaxPrice = !qty ? 0 : roundOffPrice(getBeforeTaxPrice(calculatePriceForCartItem(curr[hashId], qty)));
        let schemePrice = schemeToApply?.discount_addon === "discount_without_addon" ? getBeforeTaxPrice(calculatePriceForCartVariation(curr[hashId], qty)) : afterTaxPrice;
        if (schemeToApply?.discount_tax) {
          schemePrice += roundOffPrice(getTaxPrice(afterTaxPrice, orderDetails?.payment_discount || theTax))
        }
        let disItemQty = qty;
        if(schemeToApply?.qty){
          disItemQty = parseInt(qty / schemeToApply.qty)
          schemePrice = disItemQty ? ((schemePrice / qty) * disItemQty) : 0;
        }

        const newData = {
          ...curr,
          [hashId]: {
            ...curr[hashId],
            quantity: qty,
            after_tax_price: afterTaxPrice,
            item_discount: bogo !== 0 && orderDetails.scheme.discount_type === "bogo"
              ? curr[hashId]?.item_discount
                ? curr[hashId].item_discount
                : 0
              : roundOffPrice(getItemDiscount(
                  schemePrice,
                  curr[hashId],
                  disItemQty
                )),
            discount_type: schemeToApply
              ? schemeToApply.discount_type
              : "",
            scheme_id: schemeToApply ? schemeToApply.id : "",
          },
        };
        return newData;
      });
    }
  }

  // item wise discount
  const handleSetItemDiscount = (id, dis = 0) => {
    animate.current = "";
    const hashId = id;
    if(Number(dis) > 100){
      toast.error("Discount cannot be greater than 100%", toastObj);
      return false
    }
    const discount = Number(dis)
  
    if (cartItems[hashId]) {
      // add cart item already exist
      setCartItems((curr) => {
        const afterTaxPrice = curr[hashId].after_tax_price;
        let schemePrice = discount ? afterTaxPrice : 0;
        // if (discount) {
        //   schemePrice += roundOffPrice(getTaxPrice(afterTaxPrice, orderDetails?.payment_discount || theTax))
        // }

        const item = {
          ...curr[hashId],
          discount: discount,
          discount_type: discount ? "percentage" : "",
          scheme_id: "",
        }
        const newData = {
          ...curr,
          [hashId]: {
            ...item,
            item_discount: (bogo !== 0 && orderDetails.scheme.discount_type === "bogo")
              ? (item?.item_discount
                ? item.item_discount
                : 0)
              : roundOffPrice(getItemDiscount(
                  schemePrice,
                  item,
                  item.quantity
                )),
          },
        };
        return newData;
      });
    }
  }

  //check if add in delelte item already
  const checkDeleteItem = (hashId) => {
    if (
      order_id && deletedItemsOnEdit &&
      deletedItemsOnEdit[hashId] &&
      Number(deletedItemsOnEdit[hashId]?.quantity) > 1
      // && Object.keys(deletedItemsOnEdit).includes(String(hashId))
    ) {
      const deleteItem = deletedItemsOnEdit[hashId];
      setDeletedItemsOnEdit((curr) => ({
        ...curr,
        [hashId]: {
          ...deleteItem,
          quantity: deletedItemsOnEdit[hashId].quantity - 1,
        },
      }));
    }
  }

  // add to cart 
  const addToCart = (
    id,
    item,
    edit = false,
  ) => {

    // stock validation
    //  - Validate
    //  - Check scheme
    //  - Check stock
    //  - Add To Cart

    // token add
    if (!order_id && !orderDetails.token?.id) {
      tokenNumber();
    }

    if (item.item.has_property === "1" || item.item.has_variation === "1") {
      const hashId = createHash(item);
      checkDeleteItem(hashId)
      handleNewItem(item, id, hashId, edit);
    }
    //  Item can be added to cart immediately
    else {
      //  Cart has Item
      checkDeleteItem(item.item.id)
      handleNewItem(item, id, item.item.id, edit);
    }

    setShowModal(false);

  };

  //remove offer
  const removeScheme = () => {
    setOrderDetails((curr) => {
      const newData = {
        ...curr,
        discount: 0,
        card_number: "",
        payment_discount: null,
        payment_dis_type: "",
        card_number_settle: "",
        scheme: {
          scheme_id: null,
          scheme_name: "",
          cap_amount: 0,
          min_order_amount: 0,
          discount_amount: 0,
          open_discount: null,
          discount_type: "",
          how_much_discount: null,
          discount_addon: "",
          discount_tax: 0,
        },
      };
      return newData;
    });
    calculateTax(cartSubTotal, 0);
  };

  // card offer
  const handleCardSubmit = async (e) => {
    if (orderDetails.card_number === "") {
      toast.error(`${_t(t("Please enter the card number"))}`, toastObj);
    } else if (orderDetails.card_number.length > 16) {
      toast.error(
        `${_t(t("The card number should not be longer than 16 digits"))}`,
        toastObj
      );
    } else if (orderDetails.card_number.length < 8) {
      toast.error(
        `${_t(t("The card number should not be shorter than 8 digits"))}`,
        toastObj
      );
    } else {
      const schemeOffer = schemeForSearchObj[parseInt(orderDetails.scheme.scheme_id)];
      const cardsInfoIds = JSON.parse(schemeOffer?.card_info_ids || "[]");

      if ((cardsInfoIds && cardsInfoIds.length) || schemeOffer.voucher_required) {
        if (schemeOffer.voucher_required) {
          if (schemeOffer?.card_info_ids) {
            setLoading(true)
            const res = await getVoucherUsage(orderDetails.card_number, cardsInfoIds, "voucher")
            if (res && (res?.status === 0)) {
              toast.error(`${_t(t(res.message))}`, toastObj);
              setLoading(false)
              return;
            }
            setLoading(false)
            handleSetOffer(schemeOffer, res);
            cardModal.current.classList.remove("showing");
            return;
          }
        } else {
          const applicableIbans = cardForSearch && cardForSearch.filter((cardInfo) =>
            cardsInfoIds.includes(cardInfo.id)
          );
          if (applicableIbans.length) {
            for (const applicableIban of applicableIbans) {
              if (orderDetails.card_number.startsWith(applicableIban.iban_number)) {
                // if(applicableIban.type === "voucher"){
                //   const res = await getVoucherUsage(orderDetails.card_number,applicableIban.type)
                //   if(res && (res?.status === 0)){
                //     toast.error(`${_t(t(res.message))}`, toastObj);
                //     return;
                //   }
                // }
                let iban = {...applicableIban}
                if(applicableIban.special_discount){
                  const currDate = moment(new Date());
                  const startDate = moment(applicableIban.start_date).format("LLL");
                  const endDate = moment(applicableIban.end_date).format("LLL");
                  if (currDate.isBetween(startDate, endDate) && applicableIban.extra_discount) {
                    iban.discount = Number(applicableIban.extra_discount)
                  }
                }
                handleSetOffer(schemeOffer, iban);
                cardModal.current.classList.remove("showing");
                return;
              }
            }
            toast.error(`${_t(t("Offer is not valid on your card."))}`, toastObj);
            removeScheme();
          }
        }
      } else {
        toast.error(`${_t(t("Offer is not valid."))}`, toastObj);
        removeScheme();
      }
      cardModal.current.classList.remove("showing");
    }
  }

  const hanldeDiscountPercent = (subtotal, value) => {
    let discountPercent = Number(value);
    if (discountPercent > 100) discountPercent = 100;
    const baseAmount = orderDetails.scheme?.discount_tax
      ? (subtotal + roundOffPrice(getTax(theTax, subtotal))) : subtotal;
    
    const discountAmount = roundOffPrice((baseAmount / 100) * discountPercent);
    setOrderDetails((curr) => ({
      ...curr,
      discount: discountPercent,
      scheme: {
        ...curr.scheme,
        discount_amount: discountAmount,
        how_much_discount: discountPercent
      }
    }));
    calculateTax(subtotal, discountAmount)

  }

  // mannual offer selection
  const handleSetOffer = (scheme, cardInfo = null) => {
    if(!scheme){
      return;
    }
    const currDate = moment(new Date());
    const startDate = moment(scheme.start_date).format("LLL");
    const endDate = moment(scheme.end_date).format("LLL");
    const day = moment(currDate).format("ddd");
    const scheduling = JSON.parse(scheme.schedule);

    const minOrderAmount = parseFloat(scheme?.min_order_amount) || 0;
    if (minOrderAmount > 0) {
      const orderAmount = Number(cartTotal);

      if (orderAmount < minOrderAmount) {
        toast.error(`${_t(t(`Minimum order amount should be at least ${minOrderAmount}`))}`, toastObj);
        return false;
      }
    }

    // Specify the time format when parsing
    if (!currDate.isBetween(startDate, endDate)) {
      toast.error("Offer is not valid", toastObj);
      return false;
    } else if (scheduling && scheduling?.length > 0 && !scheduling.includes(day)) {
      toast.error("Offer day is not valid", toastObj);
      return false;
    } else if (scheme.time_schedule == 1 && !checkBetweenTime(scheme.from_time,scheme.to_time)) {
      toast.error("Offer time is not valid", toastObj);
      return false;
    }

    // offer bogo
    if (scheme.discount_type === "bogo" && Object.keys(cartItems).length > 0) {
      setCartItems((currCartItems) => {
        let bogoOffer = true;
        const newData = { ...currCartItems };
        Object.keys(currCartItems).reverse().forEach((index) => {
          const item = currCartItems[index];
          let valid = checkOfferValidation(scheme, item);

          if (valid && bogoOffer) {
            newData[index] = {
              ...item,
              item_discount: 0,
              scheme_id: scheme.id,
              discount: parseFloat(scheme.how_much_discount),
              discount_type: scheme.discount_type,
              offer_type: "bogo",
            };
            bogoOffer = false;
          } else {
            newData[index] = {
              ...item,
              item_discount: 0,
              discount: 0,
              discount_type: "",
              scheme_id: "",
            };
          }
        });
        return newData;
      });
    } else {
      let discountPercent = scheme
      if (cardInfo !== null) {
        discountPercent = {
          ...scheme,
          how_much_discount: cardInfo.discount
            ? parseFloat(cardInfo.discount)
            : orderDetails.discount,
        }
      }

      setCartItems((currCartItems) => {
        const newData = {};
        for (const hash in currCartItems) {
          const item = currCartItems[hash];
          let valid = checkOfferValidation(scheme, item);
          if (valid) {
            let schemePrice = scheme?.discount_addon === "discount_without_addon" ? getBeforeTaxPrice(calculatePriceForCartVariation(item, item.quantity)) : item.after_tax_price;
            if (scheme?.discount_tax) {
              schemePrice += roundOffPrice(getTaxPrice(item.after_tax_price, orderDetails?.payment_discount || theTax))
            }
            let disItemQty = item.quantity;
            if(scheme?.qty){
              disItemQty = parseInt(item.quantity / scheme.qty)
              schemePrice = disItemQty ? ((schemePrice / item.quantity) * disItemQty) : 0;
            }
            newData[hash] = {
              ...item,
              item_discount: roundOffPrice(getInitialItemDiscount(
                schemePrice,
                discountPercent,
                disItemQty
              )),
              scheme_id: scheme.id,
              discount: parseFloat(discountPercent.how_much_discount),
              discount_type: scheme.discount_type,
            };
            delete newData[hash].offer_type;
          } else {
            newData[hash] = {
              ...item,
              item_discount: 0,
              discount: 0,
              discount_type: "",
              scheme_id: "",
            };
            delete newData[hash].offer_type;
          }
        }
        return newData;
      });
    }

    if (scheme.open_discount) {
      discountInput.current = false;
    } else {
      discountInput.current = true;
    }
    // in case of card and discount exceeding cap_amount
    // the cap amount is the new discount amount
    // (adding key 'capAmountMet' to orderDetails object to remove discount easily)
    // let capAmountMet = false;

    // let dis = 0;
    // let capAmount = 0;
    // if (cardInfo !== null) {
    //   const cartSubTotalValue = parseFloat(cartSubTotal);
    //   dis = ((cartSubTotalValue / 100) * cardDiscount).toFixed(2);
    //   capAmount = parseFloat(scheme.cap_amount);
    //   if (
    //     scheme.card_required &&
    //     capAmount > 0 &&
    //     capAmount < parseFloat(dis)
    //   ) {
    //     capAmountMet = true;
    //     dis = capAmount;
    //     capAmount = parseFloat(scheme.cap_amount);
    //   } else {
    //     dis = ((cartSubTotalValue / 100) * cardDiscount).toFixed(2);
    //   }
    //   discount =  cardInfo.discount ? cardDiscount : orderDetails.discount;

    //   setOrderDetails((curr) => ({
    //     ...curr,
    //     discount: discount,
    //     capAmountMet: capAmountMet,
    //     scheme: {
    //       scheme_id: scheme.id,
    //       scheme_name: scheme.name,
    //       cap_amount: 500,
    //       discount_type: scheme.discount_type,
    //       open_discount: scheme.open_discount,
    //       how_much_discount: cardInfo.discount
    //         ? parseFloat(cardInfo.discount)
    //         : orderDetails.discount,
    //       discount_amount: dis,
    //     },
    //   }));
    // } else {
    // if (scheme) {
    //   if (scheme.discount_type.match(/fixed/i)) {
    //     discount = 0;
    //   } else {
    //     discount = scheme.how_much_discount ? parseFloat(scheme.how_much_discount) : orderDetails.discount;
    //   }
    // }   
    // setOrderDetails((curr) => {
    //   const {capAmountMet,...current} = curr
    //   const newData = {
    //   ...curr,
    //   discount:
    //     scheme && scheme?.how_much_discount
    //       ? scheme?.discount_type.toLowerCase() === "fixed"
    //         ? 0
    //         : parseFloat(scheme.how_much_discount)
    //       : orderDetails.discount,
    //   card_number: "",
    //   scheme: {
    //     scheme_id: scheme.id,
    //     scheme_name: scheme.name,
    //     cap_amount: 500,
    //     discount_type: scheme.discount_type,
    //     open_discount: scheme.open_discount,
    //     how_much_discount: parseFloat(scheme.how_much_discount),
    //   },
    // }
    // return newData;
    // });
    // }

    let discount = 0;
    if (scheme) {
      if (scheme.discount_type.toLowerCase() === "fixed") {
        discount = 0;
      } else if (cardInfo !== null) {
        const cardDiscount = parseFloat(cardInfo.discount);
        discount = cardDiscount ? cardDiscount : orderDetails.discount;
      } else {
        discount = scheme.how_much_discount ? parseFloat(scheme.how_much_discount) : orderDetails.discount;
      }
    }

    let howMuchDis = parseFloat(scheme.how_much_discount);
    const discountAmount = scheme.open_discount ? "" : 0;
    if (cardInfo !== null) {
      howMuchDis = cardInfo.discount
        ? parseFloat(cardInfo.discount)
        : orderDetails.discount;
    }

    setOrderDetails((curr) => {
      const newData = {
        ...curr,
        discount: discount,
        card_number: cardInfo !== null ? orderDetails.card_number : "",
        scheme: {
          scheme_id: scheme.id,
          scheme_name: scheme.name,
          cap_amount: parseFloat(cardInfo?.cap_amount) ? parseFloat(cardInfo?.cap_amount) : parseFloat(scheme.cap_amount),
          min_order_amount: parseFloat(scheme?.min_order_amount ?? 0),
          discount_type: scheme.discount_type,
          open_discount: scheme.open_discount,
          how_much_discount: howMuchDis,
          discount_amount: discountAmount,
          discount_addon: scheme.discount_addon,
          discount_tax: scheme?.discount_tax || 0,
        },
      }
      return newData;
    });

    if ((scheme.card_required || scheme?.voucher_required) && !scheme?.discount && !cardInfo) {
      cardModal.current.classList += " showing";
      setOrderDetails((curr) => {
        const newData = {
          ...curr,
          payment_dis_type: "",
          payment_discount: null,
        }
        return newData;
      });
      return;
    }
    setBogo(0);
  };

  // change item cart item if variartion/property
  const editCartItem = (itemId) => {
    const itemObj = cartItems[itemId];
    if (
      itemObj.item.has_property === "1" ||
      itemObj.item.has_variation === "1"
    ) {
      setSelectedFoodItem(itemObj);
      setSelectedFoodItemId(itemId);
      setShowModal(true);
    }
  };

  // empty all items selected
  const emptyCard = () => {
    emptyCardEdit();
    setBackModal(false);
    if (order_id) {
      history.push("/dashboard/pos");
    }
    if (!order_id && authUserInfo.details.user_type === "call_center" && parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1) {
      if(authUserInfo.details?.default_order_id && authUserInfo.details?.default_party_id){
        setCounterDefaultDetails()
      }else{
        setModalOrderType(true)
      }
    }
  };

  // item comments 
  const updateComments = (itemId, value = "", modal = false) => {
    animate.current = false;
    setCartItems((prevCartItems) => ({
      ...prevCartItems,
      [itemId]: {
        ...prevCartItems[itemId],
        comments: value,
      },
    }));
    setCommentId(null)
  }

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    })
  };

  // item image 
  const updateItemImage = async (itemId, value) => {
    animate.current = false;
    let image = "";
    if (value) {
      const base64String = value && await convertToBase64(value);
      image = {
        url: base64String,
        name: value.name,
      }
    }
    setCartItems((prevCartItems) => ({
      ...prevCartItems,
      [itemId]: {
        ...prevCartItems[itemId],
        image: image,
      },
    }));
  }

  //delete prp item
  const deletePrpItem = (deletedItemFromEdit) => {
    const propertyDelete = [];
    if (
      deletedItemFromEdit.hasOwnProperty("properties") &&
      deletedItemFromEdit.properties
    ) {
      Object.values(deletedItemFromEdit.properties).forEach((itm) => {
        for (const key in itm) {
          propertyDelete.push(itm[key]);
        }
      })
    }
    return propertyDelete;
  }

  //delete cart item
  const deleteCartItem = (itemId, deleteMade) => {
    const newObj = { ...cartItems };

    const bogoDltItem = newObj[itemId].offer_type === "bogo" && newObj[itemId].item_discount === 0;
    const bogoDlt = () => {
      for (let key in cartItems) {
        if (
          cartItems[key].offer_type === "bogo" &&
          bogo >= getBeforeTaxPrice(calculatePriceForCartVariation(cartItems[key], 1))
        ) {
          delete newObj[key];
          setBogo(0);
        }
      }
    }

    if (order_id) {
      const deletedItemFromEdit = newObj[itemId];
      const pickedPropertyDelete = deletePrpItem(deletedItemFromEdit);
      // edit made unmade delete item
      if (newObj[itemId].new === false) {
        if (deletedItemFromEdit) {
          const updateItem = {
            ...deletedItemFromEdit,
            reason: deleteReason,
            status: deleteMade ? "made" : "unmade",
            print_status: "deleted",
            properties: pickedPropertyDelete ? pickedPropertyDelete : null,
          }
          const existingItemAdd = itemAdd && itemAdd[itemId];
          if (deletedItemsOnEdit[itemId]) {
            setDeletedItemsOnEdit((curr) => ({
              ...curr,
              [itemId]: {
                ...updateItem,
                quantity:
                  deletedItemsOnEdit[itemId].quantity +
                  deletedItemFromEdit.quantity,
              },
            }));

          } else if (existingItemAdd) {
            setDeletedItemsOnEdit((curr) => ({
              ...curr,
              [itemId]: {
                ...updateItem,
                quantity:
                  deletedItemFromEdit.quantity - itemAdd[itemId].quantity,
              },
            }));
          } else {
            setDeletedItemsOnEdit((curr) => ({
              ...curr,
              [itemId]: {
                ...updateItem,
              },
            }));
          }
          // reset
          setDeleteReason("");
        }
      }

      if (
        bogoDltItem &&
        !newObj[itemId].new
      ) {
        for (let key in cartItems) {
          if (
            cartItems[key].offer_type === "bogo" &&
            bogo >= (getBeforeTaxPrice(calculatePriceForCartVariation(cartItems[key], 1)))
          ) {

            if (newObj[itemId] !== cartItems[key]) {
              setDeletedItemsOnEdit((curr) => ({
                ...curr,
                [key]: {
                  ...cartItems[key],
                  reason: deleteReason,
                  status: deleteMade ? "made" : "unmade",
                  print_status: "deleted",
                  properties: pickedPropertyDelete
                    ? pickedPropertyDelete
                    : null,
                },
              }));
            }
            delete newObj[key];
            setBogo(0);
          }
        }
      } else {
        if (
          newObj[itemId].new && bogoDltItem
        ) {
          bogoDlt()
        }
      }
    }
    if (
      !order_id && bogoDltItem
    ) {
      // delete bogo offer
      bogoDlt()
    } else {
      delete newObj[itemId];
    }

    setCartItems(newObj);
  };

  // - minus functionality
  const deleteOneCartItem = (itemId, status) => {
    const newObj = { ...cartItems };
    const deleteItem = newObj[itemId];
    Cartanimation(itemId)
    const afterTaxPrice = roundOffPrice(getBeforeTaxPrice(calculatePriceForCartItem(deleteItem, deleteItem.quantity - 1)));
    let schemePrice = afterTaxPrice;
    if (orderDetails.scheme.scheme_id && orderDetails.scheme.discount_addon === "discount_without_addon") {
      schemePrice = getBeforeTaxPrice(calculatePriceForCartVariation(deleteItem, deleteItem.quantity - 1));
    } else if (deleteItem.scheme_id && schemeForSearchObj[parseInt(deleteItem.scheme_id)] && schemeForSearchObj[parseInt(deleteItem.scheme_id)].discount_addon === "discount_without_addon") {
      schemePrice = getBeforeTaxPrice(calculatePriceForCartVariation(deleteItem, deleteItem.quantity - 1));
    }

    if ((orderDetails?.scheme.scheme_id && orderDetails?.scheme.discount_tax) || (deleteItem.scheme_id && schemeForSearchObj[parseInt(deleteItem.scheme_id)] && schemeForSearchObj[parseInt(deleteItem.scheme_id)]?.discount_tax)) {
      schemePrice += roundOffPrice(getTaxPrice(afterTaxPrice, orderDetails?.payment_discount || theTax))
    }

    let disItemQty = deleteItem.quantity - 1;
    if(schemeForSearchObj[parseInt(deleteItem.scheme_id)]?.qty){
      disItemQty = parseInt(disItemQty / schemeForSearchObj[parseInt(deleteItem.scheme_id)].qty);
      schemePrice = disItemQty ? ((schemePrice / (deleteItem.quantity - 1)) * disItemQty) : 0;
    }
    const finalObj = {
      ...newObj,
      [itemId]: {
        ...deleteItem,
        after_tax_price: afterTaxPrice,
        item_discount: roundOffPrice(getItemDiscount(
          schemePrice,
          deleteItem,
          disItemQty
        )),
        quantity: deleteItem.quantity - 1,
      },
    };

    if (order_id) {
      const pickedPropertyDelete = deletePrpItem(deleteItem);
      if (newObj[itemId].new === false) {
        const deleteQty = deletedItemsOnEdit[itemId] ? (deletedItemsOnEdit[itemId].quantity + 1) : 1;
        const afterTaxPrice1 = roundOffPrice(getBeforeTaxPrice(calculatePriceForCartItem(deleteItem, deleteQty)));
        const updatedItem = {
          ...deleteItem,
          after_tax_price: afterTaxPrice1,
          price: afterTaxPrice1,
          reason: deletedItemsOnEdit[itemId] ? deletedItemsOnEdit[itemId].reason : deleteReason,
          status: status ? "made" : "unmade",
          print_status: "deleted",
          properties: pickedPropertyDelete ? pickedPropertyDelete : null,
        }
        
        if (
          itemAdd && itemAdd[itemId]
        ) {
          setDeletedItemsOnEdit((curr) => ({
            ...curr,
          }));
        } else {
          setDeletedItemsOnEdit((curr) => ({
            ...curr,
            [itemId]: {
              ...updatedItem,
              quantity: deleteQty,
            },
          }));
        }
        // reset
        setDeleteReason("");
      }
    }
    setCartItems(finalObj);
  };

  const getBeforeTaxPrice = (price) => {
    if (taxType === "inclusive") {
      return price / (1 + (theTax / 100));
    }
    return price;
  };

  // tax cal on change tax type
  const handleTaxOnPaymentTypeChange = (payment_type) => {
    let paymentTypeTax = orderDetails.branch.payment_tax[payment_type.name];
    const vat = checkTaxType(cartSubTotal, orderDetails.scheme.discount_amount);
    const discount = orderDetails.scheme?.discount_amount ? orderDetails.scheme.discount_amount : 0
    // if payment type tax exists
    if (paymentTypeTax) {
      paymentTypeTax = parseFloat(paymentTypeTax);
      const newState = {
        subTotal: cartSubTotal,
        vat: paymentTypeTax,
        vatAmount: paymentTypeTax > 0 ? vat ? (vat * (paymentTypeTax / 100)) : 0 : theVat,
        serviceCharge: orderDetails.branch.service_fees,
        serviceChargeAmount: serviceCharges,
        deliveryCharges: deliveryCharges,
        discount: discount,
        totalPayable: (cartTotal - theVat) + (vat * (paymentTypeTax / 100)),
        showModal: true,
        payment_type_name: payment_type.name,
        taxCalSelect: false
      };
      setPaymentTypeModalState(newState);
    } else {
      const newState = {
        subTotal: cartSubTotal,
        vat: orderDetails.branch.branch_tax,
        vatAmount: theVat,
        serviceCharge: orderDetails.branch.service_fees,
        serviceChargeAmount: serviceCharges,
        deliveryCharges: deliveryCharges,
        discount: discount,
        totalPayable: cartTotal,
        showModal: true,
        payment_type_name: payment_type.name,
        taxCalSelect: false
      };
      setPaymentTypeModalState(newState);
    }
  };

  //settle button

  const handleSettleOrderButton = (e) => {

    if (newOrder && newOrder.length > 0) {
      if (orderDetails && selectedDeptTag !== null) {
        if (
          orderDetails.orderTypeDetails === undefined || orderDetails.orderTypeDetails === null
        ) {
          toast.error("Please select order type", { ...toastObj, toastId: "missing-order-type" });
        } else {

          if (parseInt(JSON.parse(getSystemSettings(generalSettings, "customer_validation"))[selectedDeliveryType.name]) === 1) {
            if (orderDetails.newCustomerInfo.name == "" || orderDetails.newCustomerInfo.phn_no == "" || !orderDetails.newCustomerInfo?.is_confirm) {
              setModal9Show(true)
              toast.error(`Please fill customer ${orderDetails.newCustomerInfo.name == "" ? "name" : ""} ${orderDetails.newCustomerInfo.name == "" && orderDetails.newCustomerInfo.phn_no == "" ? "&" : ""} ${orderDetails.newCustomerInfo.phn_no == "" ? "phone number" : ""} & press confirm`);
              return false
            }
          }
          const tax = roundOffPrice(theVat);
          let total = roundOffPrice(cartTotal);

          if (getSystemSettings(generalSettings, "user_wise_integration") == 1 ? authUserInfo.details.sbr_enabled === 1 : (orderDetails.branch.sbr_integration === 1 ||
            orderDetails.branch.fbr_integration === 1 || orderDetails.branch.cbr_integration === 1 || orderDetails.branch?.kpra_integration === 1
            || orderDetails.branch?.pbr_integration === 1)) {
            total = roundOffPrice((parseFloat(cartTotal) + 1));
          }
          setTheVatSettle(tax);
          setTotalSettle(total);
          setOrderDetails((curr) => ({
            ...curr,
            payment_type: null,
          }));
          if (getSystemSettings(generalSettings, "loyality_enable") === "techmixers") {
            setloyaltyPoint({
              ...loyaltyPoint,
              phn_no: orderDetails.newCustomerInfo.phn_no ?? "",
              ...(!orderDetails.newCustomerInfo.phn_no && { type: "get-info" })
            })
          }
          setShowSettle(true);
        }
      } else {
        toast.error("Please select a department tag", { ...toastObj, toastId: "missing-department-tag" });
      }
    } else {
      toast.error("Please add items in order first", { ...toastObj, toastId: "empty-order-list" });
    }
  };

  //call after successful order submit and settle
  const handleOrderSubmitSuccessful = () => {
    let partyName = "";
    let phone = "";
    if (selectedParty.name.match(/food(.*)panda/i)) {
      partyName = "Food Panda";
      phone = "00000000000"
    }
    let branch = null;
    let OrderType = null;
    let party = null;

    if (authUserInfo && (authUserInfo.details.user_type === "call_center") && parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1) {
      setSelectedBranch(null);
      setSelectedDeliveryType(null);
      setSelectedParty(null);
      setZoneArea(null);
      setArea(null);
      setModalOrderType(true);
      setDeliveryCharges(0);
      setTheTax(0);
      branch = null;
      OrderType = null;
      party = null;
    } else {
      setSelectedBranch(selectedBranch);
      setSelectedDeliveryType(selectedDeliveryType);
      setSelectedParty(selectedParty);
      if ((selectedDeliveryType && selectedDeliveryType.name.toLowerCase() === "delivery")) {
        setDeliveryCharges(
          parseFloat(getSystemSettings(generalSettings, "delivery_charges"))
        );
      } else {
        deliveryInput.current = true;
        setDeliveryCharges(0);
      }
      branch = orderDetails.branch;
      OrderType = orderDetails.orderTypeDetails;
      party = orderDetails.partyDetails;
    }

    setNewOrder([]);
    setFoodGroupsToPrint({});
    setSelectTable({});
    setKotPrintIdx(0);
    setSelectedKot({});
    setloyaltyPoint({
      qr_code: "",
      availablePoints: 0,
      earnedPoints: 0,
      phn_no: "",
      redeemPoints: 0,
      verified: true,
      type: getSystemSettings(generalSettings, "loyality_enable") === "techmixers" ? "" : ("token"),
      maxRedeemPoints: "",
      customerName: "",
    });
    fbrInvoiceNum.current = null;
    srbInvoiceNum.current = {
      number: "",
      url: "",
    };
    // setSrbInvoiceNum(null);
    // setFbrInvoiceNum(null);
    setCartSubTotal(0);
    setTheVat(0);
    setCartTotal(0);
    setReturnMoneyUsd(0);
    setPaidMoney(0);
    isSettle.current = 0;
    setBogo(0);
    setGuestSelected(1);
    setServiceCharges(0);
    setOrderDetails({
      branch: branch,
      table: null,
      waiter: null,
      payment_type: null,
      card_number: "",
      payment_discount: null,
      payment_dis_type: "",
      card_number_settle: "",
      payment_amount: null,
      total_guest: 1,
      is_reservation: 0,
      table_id: null,
      table_name: null,
      discount_voucher: "",
      note_to_rider: "",
      order_tip: 0,
      newCustomerInfo: {
        id: null,
        name: partyName,
        email: "",
        phn_no: phone,
        address: "",
        ref_no: "",
        ntn_no: "",
        gender: "",
        dob: "",
        nearest_landmark: "",
        alt_phn_no: "",
        modal: false,
        order: null,
        is_confirm: false,
      },
      scheme: {
        scheme_id: null,
        scheme_name: "",
        cap_amount: 0,
        min_order_amount: 0,
        discount_amount: 0,
        open_discount: null,
        discount_type: "",
        how_much_discount: null,
        discount_addon: "",
        discount_tax: 0,
      },
      orderTypeDetails: OrderType,
      partyDetails: party,
      token: null,
      unique_token: null,
      order_No: null,
      serviceCharge: 0,
      discount: 0,
      service_amount: 0,
      pre_order_date: null,
      is_advance_booking: 0,
      is_edit: 0,
      pre_order_modal: false,
      advance_amount: 0,
      is_split: 0,
    });
    setCartItems({});
    // settle order settle reset
    setShowSettle(false);
    setTotalSettle(0);
    setTheVatSettle(0);
    setPaidMoney(0);
    setSearchInput("");
    if (inputSearch.current) inputSearch.current.value = "";
    if (navigator.onLine) {
      toast.success(`${_t(t("Order has been taken"))}`, toastObj);
    }

    setUserLock([]);
    setManagerId(null);
    setSearchedFoodItem({ list: null, searched: false })
    setLoading(false);
    //set token'
    if (networkStatus && parseInt(authUserInfo.details?.offline_enable) !== 1) {
      localStorage.setItem("order_id", newSettings.workPeriod.token);
    } else {
      if (localStorage.getItem("order_id")) {
        localStorage.setItem("order_id", parseInt(localStorage.getItem("order_id")) + 1);
      } else {
        localStorage.setItem("order_id", newSettings.workPeriod.token);
      }
    }

    if (authUserInfo.details.user_type === "call_center") {
      setCallCenterPayment({
        payment_type: "Cash",
        transaction_no: "",
        transactionModal: false,
      });
    }
    discountInput.current = true;
    //sound
    if (!order_id) {
      if (getSystemSettings(generalSettings, "play_sound") === "1") {
        let beep = document.getElementById("myAudio");
        beep.play();
      }
    } else {
      history.push("/dashboard/pos/submitted");
    }
    setButtonDisabled(false);
  };

  const isLocked = (type = "") => {
    // getSystemSettings(generalSettings, "offers_lock_status") == 1 &&
    return (authUserInfo.details.user_type === "staff" || authUserInfo?.details.user_type === "waiter") &&
      (authUserInfo.details.user_passcode || managerPasscode) &&
      !userLock.includes(type)
      ? true
      : false;
  };
  // handle auth user
  const authenticateStaffUser = (componentType) => {
    // console.log("componentType", componentType, userLock);
    if (!userLock.includes(componentType)) {
      setShowPasswordPopup(true);
      setComponentUnlock(componentType);
    }
  };

  const hanleCancelAuthenticate = () => {
    setShowPasswordPopup(false);
    setComponentUnlock("");
  };

  const onSuccessAuthenticationStaff = () => {
    setShowPasswordPopup(false);
    setUserLock([...userLock, componentUnlock]);
  };

  //after order submit or settle
  //All Receipt Control from this handle
  const getCurrentSelectedKots = useRef();
  getCurrentSelectedKots.current = selectedKot;
  const getCurrentKotPrintIndex = useRef();
  getCurrentKotPrintIndex.current = kotPrintIdx;

  const handleRemoveItemFromOrderListOnEdit = (deleteMade, index) => {
    setAddReasonModalShowing(null);
    deleteCartItem(index, deleteMade);
  };

  const handleOrderItemQtyOnEdit = (id, status, action, activeitem) => {
    if (!(id in deletedItemsOnEdit) && status === null)
      setAddReasonModalShowing({
        action: "decrease",
        params: [action, activeitem, id],
      });
    else deleteOneCartItem(id, status);
  };

  const addReasonOnSubmit = (status) => {
    if (!addReasonModalShowing || !addReasonModalShowing.action) return;
    if (!deleteReason) {
      toast.error("Reason cannot be empty.", toastObj);
      return;
    }
    if (addReasonModalShowing.action === "remove") {
      setAddReasonModalShowing(null);
      return handleRemoveItemFromOrderListOnEdit(
        status,
        ...addReasonModalShowing.params
      );
    }
    if (addReasonModalShowing.action === "decrease") {
      setAddReasonModalShowing(null);
      return handleOrderItemQtyOnEdit(...addReasonModalShowing.params, status);
    }
  };

  // kot for kitchen
  const handleKotItems = () => {
    const kotObj = { ...selectedKot };

    let orderItems = [...newOrder];
    // add  new and deleted items on edit
    if (order_id) {
      const addedItems = [];
      orderItems.forEach((item) => {
        if (item.new && item.new) {
          addedItems.push({
            ...item,
            print_status: "added",
          });
        }
      });
      orderItems = [
        ...Object.values(deletedItemsOnEdit),
        ...addedItems,
        ...Object.values(itemAdd),
      ];
    }
    
    const consolidatedKot = (orderDetails.branch.consolidated_kot === "true" || parseInt(orderDetails.branch.consolidated_kot) === 1);
    const branchKot = orderDetails.branch.consolidated_ip;
    //kotObj[orderDetails.branch.consolidated_ip] = { ...orderItems };
    orderItems.forEach((obj) => {
      const kotKey = obj.item.kot
        ? obj.item.kot === "No"
          ? obj.item.kot
          : obj.item.kot_ip
        : "No";
      const group = foodGroupForPOSById[obj.item.food_groups[0]];
      const groupKey = group ? group?.name : "None";

      // branch wise consolidated kot
      if (consolidatedKot) {
        if (
          kotObj.hasOwnProperty(branchKot) &&
          kotObj[branchKot] &&
          Object.keys(kotObj[branchKot])?.length
        ) {
          if (
            kotObj[branchKot].hasOwnProperty(groupKey) &&
            kotObj[branchKot][groupKey] &&
            kotObj[branchKot][groupKey]?.length
          ) {
            kotObj[branchKot] = {
              ...kotObj[branchKot],
              [groupKey]: [...kotObj[branchKot][groupKey], { ...obj }],
            };
          } else {
            kotObj[branchKot] = {
              ...kotObj[branchKot],
              [groupKey]: [{ ...obj }],
            }
          }
        } else {
          kotObj[branchKot] = {
            // ...kotObj[branchKot],
            [groupKey]: [{ ...obj }],
          };
        }
      }

      if (obj.item.is_special == "1" && obj?.properties) {
        obj.properties.forEach((prop) => {
          const kotProp = prop.item?.kot_ip
            ? prop.item.kot_ip : "No";
          const propItem = JSON.parse(JSON.stringify(prop));
          propItem.item.name = obj.item.name + " - " + propItem.item.name;

          if (
            kotObj[kotProp] &&
            kotObj.hasOwnProperty(kotProp) &&
            Object.keys(kotObj[kotProp])?.length
          ) {
            if (
              kotObj[kotProp].hasOwnProperty(groupKey) &&
              kotObj[kotProp][groupKey] &&
              kotObj[kotProp][groupKey]?.length
            ) {
              kotObj[kotProp] = {
                ...kotObj[kotProp],
                [groupKey]: [...kotObj[kotProp][groupKey], { ...obj, property: { ...propItem } }],
              };

            } else {
              kotObj[kotProp] = {
                ...kotObj[kotProp],
                [groupKey]: [{ ...obj, property: { ...propItem } }],
              };
            }
          } else {
            kotObj[kotProp] = {
              [groupKey]: [{ ...obj, property: { ...propItem } }],
            };
          }
        });
      } else {
        // item wise kot
        if (
          kotObj.hasOwnProperty(kotKey) &&
          kotObj[kotKey] &&
          Object.keys(kotObj[kotKey])?.length
        ) {
          if (
            kotObj[kotKey].hasOwnProperty(groupKey) &&
            kotObj[kotKey][groupKey] &&
            kotObj[kotKey][groupKey]?.length
          ) {

            kotObj[kotKey] = {
              ...kotObj[kotKey],
              [groupKey]: [...kotObj[kotKey][groupKey], { ...obj }],
            };

          } else {

            kotObj[kotKey] = {
              ...kotObj[kotKey],
              [groupKey]: [{ ...obj }],
            };
          }
        } else {
          // let prop1 = {};
          // if(obj.item.has_property == "1" && obj.properties?.length > 0){
          //   obj.item.property_groups.map((propertyGrpName)=>{
          //     let theGroup =
          //     propertyGroupForSearch &&
          //     propertyGroupForSearch.find(
          //       (theItem) => {
          //         return propertyGrpName === (theItem?.id) ;
          //       }
          //     );
          //     let propertWithGroup = []
          //     obj.properties.forEach(prop => {
          //       const propertyGroupIds = JSON.parse(prop.item.property_group_id);
          //       if(propertyGroupIds.includes(propertyGrpName)){
          //          propertWithGroup.push(prop)
          //       }
          //     });
          //     if(propertWithGroup && propertWithGroup?.length > 0){
          //       prop1[theGroup.name] = propertWithGroup
          //     }

          //     console.log("abcd44",prop1,propertWithGroup)
          //   })
          // }   
          kotObj[kotKey] = {
            [groupKey]: [{ ...obj }],
          };
        }
      }
    });
    setSelectedKot(kotObj);
    return kotObj;
  };

  const barcodePrintRef = useRef();

  const handleBarCodePrint = useReactToPrint({
    content: () => barcodePrintRef.current,
    onAfterPrint: () => {
      handleOrderSubmitSuccessful();
    }
  });


  //for Customer & kithcen
  const handlePrintAll = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => new Promise((resolve) => setTimeout(resolve, 100)),
    onAfterPrint: () => {
      if (getSystemSettings(generalSettings, "print_kitchen_bill") === "1" && !orderDetails.is_advance_booking) {
        let kots = getCurrentSelectedKots.current;
        if (kots && Object.keys(kots)?.length) {
          setNextKotPrint();
        } else {
          if(orderDetails.branch?.barcode_enable){
            handleBarCodePrint()
          }else{
            handleOrderSubmitSuccessful();
          }
        }
      } else {
        if(orderDetails.branch?.barcode_enable){
          handleBarCodePrint()
        }else{
          handleOrderSubmitSuccessful();
        }
      }
    },
    removeAfterPrint: false,
  });

  /* KOT PRINTING FUNCTION */
  const setNextKotPrint = () => {
    let currentKotIdx = getCurrentKotPrintIndex.current;
    let allKots = getCurrentSelectedKots.current;
    setKotPrintIdx((curr) => curr + 1);
    if (currentKotIdx === Object.keys(allKots).length || orderDetails.is_advance_booking) {
      if(orderDetails.branch?.barcode_enable){
        handleBarCodePrint()
      }else{
        handleOrderSubmitSuccessful();
      }
    } else {
      const newNewOrder = Object.values(allKots)[currentKotIdx];
      if (Object.keys(allKots)[currentKotIdx] == orderDetails.branch.consolidated_ip) {
        con_Kot.current = "Consolidated Kot"
      } else {
        con_Kot.current = ""
      }
      // let groups;
      // setOrderFoodGroups(curr => {
      //   groups = [...curr]
      //   return curr
      // })
      // setFoodGroupsToPrint(groups.filter(group => (
      //   newNewOrder.find(order => (order.item.food_groups.includes(group.id)))
      // )))
      setFoodGroupsToPrint(newNewOrder);
      handlePrintKitchen2();
    }
  };

  const handlePrintKitchen2 = useReactToPrint({
    content: () => component2Ref.current,
    onBeforeGetContent: () => new Promise((resolve) => setTimeout(resolve, 100)),
    onAfterPrint: () => {
      setNextKotPrint();
    },
    removeAfterPrint: false,
  });

  const handleReceiptPrint = () => {
    switch ((orderDetails.branch && orderDetails.branch?.print_pos_setting) ? orderDetails.branch.print_pos_setting :
      getSystemSettings(generalSettings, "print_pos_setting")) {
      case "Customer":
        handlePrintCustomer();
        break;

      case "Kitchen":
        setNextKotPrint();
        break;

      default:
        handlePrintAll();
        break;
    }
  };

  //for Customer
  const handlePrintCustomer = useReactToPrint({
    content: () => componentRef.current,
    onBeforeGetContent: () => new Promise((resolve) => setTimeout(resolve, 100)),
    onAfterPrint: () => {
      handleOrderSubmitSuccessful();
    },
    removeAfterPrint: false,
  });

  const FocConfirmation = (e, focManagerId = null) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h3 className="px-4">{_t(t("Are you sure?"))}</h3>
            <p className="text-center">{_t(t("You want to Foc order?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary rounded-25 mb-1"
                onClick={() => {
                  onClose();
                  handleSubmitOrder(e, 0, 1, focManagerId);
                }}
              >
                {_t(t("Save"))}
              </button>
              <button className="btn btn-success ml-3 px-3 rounded-25 mb-1" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  }

  const { openFOCManagerModal } = useFOCManagerVerify({
    loading,
    setLoading
  })

  // foc accept
  const handleFocConfirmation = (e) => {

    if (!newOrder || newOrder?.length === 0) {
      ToastError({ title: t("Please add items in order list"), toastId: "empty-order-list" });
      setButtonDisabled(false);
      return
    }

    if (authUserInfo.details?.manager_foc_limit) {

      const payload = {
        dayOpenDate: newSettings.workPeriod.date,
        amount: cartTotal
      }

      const onSuccess = (managerId) => {
        FocConfirmation(e, managerId)
      }

      openFOCManagerModal(payload, onSuccess)

      return
    }

    FocConfirmation(e)

  };

  //foc item
  const handleFocItem = (type = "foc") => {
    const hashId = addFocItem.itemId + type
    setCartItems((curr) => {
      const newData = {
        ...curr,
        [hashId]: {
          ...curr[addFocItem.itemId],
          comments: addFocItem.reason,
          status: type,
          after_tax_price: 0,
          item_discount: 0,
          discount_type: "",
          scheme_id: "",
        },
      };
      if (hashId != addFocItem.itemId) delete newData[addFocItem.itemId];
      return newData;
    });
    setAddFocItem({
      modal: false,
      itemId: null,
      reason: ""
    })
  }

  const handlePreOrderConfirmation = (e) => {
    e.preventDefault();
    if (validateOrder()) {
      setOrderDetails((curr) => ({ ...curr, pre_order_modal: true }))
    }
  };

  const axiosRequest = async (hold, foc, focManagerId = null) => {
    let api = order_id ? "/settings/order-update"
      : (authUserInfo.details.user_type === "call_center"
        ? "/settings/new-callcenter-order"
        : "/settings/new-order");

    const url = getOfflineApiUrl(api);
    let localCurrency = JSON.parse(localStorage.getItem("currency"));
    let formData = getOrderObject(localCurrency, focManagerId);
    formData.is_hold = hold;
    formData.is_foc = foc;
    setLoading(true);
    networkStatus = await checkNetworkStatus();
    if (networkStatus && parseInt(authUserInfo.details?.offline_enable) === 1 && !syncOrder) {
      syncLocalOrders();
    }
    createOrUpdateOrder(url, formData, hold);
  };

  // form data for direct print to printer

  const formDataReturn = () => {
    const refNo = orderDetails.newCustomerInfo?.ref_no ? orderDetails.newCustomerInfo.ref_no : "";
    const taxAmount = (isSettle.current === 1 && theVatSettle > 0) ? theVatSettle : theVat;
    const totalAmount = (isSettle.current === 1 && totalsettle > 0) ? totalsettle : cartTotal;
    const returnAmount = roundOffPrice(Number(paidMoney) - Number(totalAmount)) > 0 ? (Number(paidMoney) - Number(totalAmount)) : 0;
    //cash card tax wise total 
    const [cardAmount, cardPercent] = totalPriceWithTax(cartTotal,cartSubTotal, theVat, orderDetails.scheme.discount_amount, orderDetails.branch, "card");
    const [cashAmount, cashPercent] = totalPriceWithTax(cartTotal,cartSubTotal, theVat, orderDetails.scheme.discount_amount, orderDetails.branch, "cash");

    let feedbackUrl = "";
    if(parseInt(getSystemSettings(generalSettings, "is_feedback")) === 1){
      feedbackUrl = window.location.origin + "/feedback/" + token_No.current?.hash_id;
    }else if(orderDetails.branch?.feedback_url){
      feedbackUrl = orderDetails.branch.feedback_url + "?uid=" + (orderDetails.token && (orderDetails.token?.order_id));
    }

    return {
      site_name: getSystemSettings(generalSettings, "siteName"),
      branch: orderDetails.branch,
      type_print_heading: getSystemSettings(
        generalSettings,
        "type_print_heading"
      ),
      party_name:
        orderDetails.orderTypeDetails.orderTypeName +
        "-" +
        orderDetails.partyDetails.partyName,
      partyDetails: orderDetails.partyDetails,
      guest: orderDetails && orderDetails.total_guest,
      isSettle: isSettle.current,
      table: orderDetails.table,
      waiter: orderDetails.waiter,
      dept_tag: selectedDeptTag,
      loyalty_points: loyaltyPoint,
      payment_type: orderDetails.payment_type,
      payment_amount: orderDetails.payment_amount,
      card_number: orderDetails.card_number,
      newCustomerInfo: orderDetails.newCustomerInfo,
      token: token_No.current,
      total_guest: orderDetails.total_guest,
      table_id: orderDetails.table_id,
      table_name: orderDetails.table_name,
      discount_voucher: orderDetails?.discount_voucher,
      tax_type: taxType,
      fixed_tax_type: parseInt(getSystemSettings(generalSettings, "fixed_inclusive_tax")) === 1,
      rider_name: "",
      rider_notes: orderDetails.note_to_rider ? orderDetails.note_to_rider : "",
      feedback_url: isSettle?.current ? feedbackUrl : "",
      //customer print
      deliveryIp: orderDetails.branch.customer_counter_ip != null && orderDetails.branch.customer_counter_ip !== "" ? orderDetails.branch.customer_counter_ip : null,
      customerIp: (() => {
        if (!orderDetails.branch?.kitchen_printer_ip) return null;
        try {
          const parsed = typeof orderDetails.branch.kitchen_printer_ip === "string" 
            ? JSON.parse(orderDetails.branch.kitchen_printer_ip) 
            : orderDetails.branch.kitchen_printer_ip;
          if (parsed && typeof parsed === "object") {
            return parsed[authUserInfo?.details?.id] || Object.values(parsed).find(ip => !!ip) || null;
          }
          return typeof parsed === "string" ? parsed : null;
        } catch (e) {
          return null;
        }
      })(),
      is_online: 0,
      customerOrder: newOrder,
      orderItems:
        !Object.keys(selectedKot).length === 0 ? selectedKot : handleKotItems(),
      serviceCharge: deliveryCharges,
      service_amount: serviceCharges,
      order_tip: orderDetails.order_tip,
      discount: orderDetails.scheme.discount_amount,
      scheme: orderDetails.scheme,
      subTotal: getSubtotalInclusiveSettle(newOrder,cartSubTotal,isSettle.current && orderDetails.payment_type?.length === 1),
      totalPayable: totalAmount,
      view_cash_card: parseInt(getSystemSettings(generalSettings, "view_cash_card")),
      cash: cashAmount,
      card: cardAmount,
      cash_percent: cashPercent,
      card_percent: cardPercent,
      paidMoney: paidMoney,
      theVat: taxAmount,
      tax_percent: taxPercent(cartSubTotal, taxAmount, orderDetails.scheme.discount_amount),
      print_tax: orderDetails.branch?.print_tax,
      dept_commission: selectedDeptTag?.commission || 0,
      workPeriod: newSettings.workPeriod,
      order_id: order_id ? order_id : null,
      orderTypeDetails: orderDetails.orderTypeDetails,
      orderFoodGroups: [],
      selectedPropertyGroup: [],
      propertyGroupForSearch: propertyGroupForSearch,
      RefNo: orderDetails && orderDetails.orderTypeDetails &&
        orderDetails.partyDetails.partyName +
        " - ref no :" + refNo,
      return_amount: returnAmount,
      print_footer: getSystemSettings(generalSettings, "type_print_footer"),
      print_bill_footer: getSystemSettings(generalSettings, "print_bill_footer"),
      kot_header: getSystemSettings(generalSettings, "kot_header"),
      user_name: authUserInfo && authUserInfo.details && authUserInfo.details.name,
      fbr_num: fbrInvoiceNum.current,
      srb_num: srbInvoiceNum.current.number,
      srb_qr_url: srbInvoiceNum.current.url,
    };
  };

  //table transfer print
  const handleLocalTablePrint = (formData) => {
    const params = new URLSearchParams(history.location?.search);
    const tableName = params.get("table");
    formData.old_table = tableName;
    let axiosConfig = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    axios
      .post(getDynamicOfflinePrintUrl("/example-app/api/table"), formData, axiosConfig)
      .then((res) => {
        console.log("RESPONSE RECEIVED: ", res);
        if (order_id) {
          history.push("/dashboard/pos/submitted");
          setButtonDisabled(false);
        } else handleOrderSubmitSuccessful();
      })
      .catch((err) => {
        if (order_id) {
          history.push("/dashboard/pos/submitted");
          setButtonDisabled(false);
        }
      });
  };

  const handleLocalPrint = (local = 0) => {
    let formData = formDataReturn();
    let axiosConfig = {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 10000,
    };

    axios
      .post(getDynamicOfflinePrintUrl("/example-app/api/test"), formData, axiosConfig)
      .then((res) => {
        console.log("RESPONSE RECEIVED: ", res);
        if (order_id) {
          if (history.location?.search?.startsWith("?table=")) {
            handleLocalTablePrint(formData)
          } else {
            history.push("/dashboard/pos/submitted");
          }
          setButtonDisabled(false);
        } else handleOrderSubmitSuccessful();
      })
      .catch((err) => {
        if(err.response?.data?.message){
          toast.error(err.response?.data?.message, toastObj)
        }
        if (!local) {
          if (authUserInfo.details.user_type === "call_center") {
            setNextKotPrint();
          } else {
            handleReceiptPrint();
            if (order_id && history.location?.search?.startsWith("?table=")) {
              handleLocalTablePrint(formData)
            }
          }
        } else if (order_id) {
          history.push("/dashboard/pos/submitted");
          setButtonDisabled(false);
        }
      });
  };

  const createOrUpdateOrder = async (url, formData, hold) => {
    if (parseInt(authUserInfo.details?.offline_enable) === 1 && authUserInfo.details.user_type !== "call_center") {
      formData.offline_status = 0;
      const offlineData = await handleSubmitOffline(formData, url);
      if (offlineData) {
        let newRes = {};
        let workperiod = [];
        workperiod.push(workPeriodListForBranch);
        newRes.data = workperiod;
        handleCreateOrUpdateOrder(newRes, false, hold);
      } else {
        setButtonDisabled(false)
      }
      setLoading(false);
    } else {
      axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          if (res.data === "exists") {
            toast.error(`${_t(_t("Order already submit, You have click submit button again & again"))}`, { ...toastObj, toastId: "duplicate-order-submit" });
            setSelectedKot({});
            setButtonDisabled(false);
            setLoading(false);
            return false
          }
          if (formData?.local) {
            handleCreateOrUpdateOrder(res, formData.local);
          } else {
            handleCreateOrUpdateOrder(res, false, hold);
          }
          setLoading(false);

        })
        .catch((error) => {
          if (parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 && error.response?.data?.message !== "") {
            toast.error(<span style={{ whiteSpace: "pre-line" }}>{error.response.data.message}</span>, toastObj);
            setSelectedKot({});
            setButtonDisabled(false);
            setLoading(false);
            return false
          }

          setFoodGroupsToPrint({});
          setKotPrintIdx(0);
          setSelectedKot({});
          let data = [];
          data.push(workPeriodListForBranch);
          //set work period
          let theWorkPeriod = null;
          if (
            orderDetails.branch !== undefined &&
            orderDetails.branch !== null &&
            authUserInfo?.details.user_type !== "waiter" &&
            (authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager")
          ) {
            theWorkPeriod =
              data[0] &&
              data[0].find((tempWorkPeriod) => {
                return (
                  (orderDetails.branch.id === parseInt(tempWorkPeriod.branch_id)) && tempWorkPeriod.ended_at === null
                );
              });
          } else {
            theWorkPeriod = data && data[0][0];
          }
          setLoading(false);
          setTimeout(() => {
            setNewSettings({
              ...newSettings,
              vat: orderDetails.branch.branch_tax,
              workPeriod:
                theWorkPeriod !== undefined ? theWorkPeriod : null,
            });
          }, 500);
          if (error.response?.data?.status === 1) {
            toast.error(`${_t(_t(error.response?.data?.message))}`, toastObj);
          } else if (error.response?.data?.status === 2) {
            toast.error(`${_t(_t(error.response?.data?.message))}`, toastObj);
            emptyCardOnChange(selectedDeliveryType, selectedParty);
          } else if (networkStatus) {
            toast.error(`${_t(_t("Please contact support"))}`, { ...toastObj, toastId: "contact-support-error" });
          } else {
            toast.error(`${_t(_t("Please check your internet connection"))}`, { ...toastObj, toastId: "network-error" });
          }
          setButtonDisabled(false);
        });
    }
  };

  const handleCreateOrUpdateOrder = (res, local = false, hold) => {
    if (syncSettle.current === true) {
      isSettle.current = 1;
      fbrInvoiceNum.current = res.data[2];
      srbInvoiceNum.current = {
        number:res.data[3],
        url:res.data[res.data.length - 2]
      };
      // setFbrInvoiceNum(res.data[2]);
      // setSrbInvoiceNum(res.data[3]);
    } else {
      isSettle.current = 0;
    }

    if (res.data !== "ended") {
      if (local == false && !order_id) {
        let formatTime = moment(res.data[3]).format('DD-MMM-YYYY hh:mm A');
        const orderId = res.data[res.data.length - 2];
        token_No.current = {
          id: res.data[1] ? res.data[1] : orderDetails.token?.id,
          invoice_no: parseInt(getSystemSettings(generalSettings, "order_no")) === 1 ? (res.data[2] || "") :  "",
          time: formatTime, 
          order_id: orderId
        }
        setOrderDetails({
          ...orderDetails,
          token: {
            ...orderDetails.token,
            id: res.data[1] ? res.data[1] : orderDetails.token?.id,
            order_id: orderId
          },
          order_No: res.data[2] ? res.data[2] : orderDetails.token?.id,
        })
      }

      //getFoodGroup();
      if (isTimeExpired("apiTime")) {
        setApiTime("apiTime");
        getFoodGroupForPOS();
      }
      // setWorkPeriodList(res.data[0][0]);
      setWorkPeriodListForBranch(res.data[0]);
      const directPrint = parseInt(orderDetails.branch?.direct_ip_print) || parseInt(getSystemSettings(generalSettings, "direct_ip_print"));

      // print on submit
      if (authUserInfo.details.user_type !== "call_center" && !hold) {
        if (res.data[0] && local == false) {
          directPrint ? handleLocalPrint(local) : handleReceiptPrint();
        }
      } else {
        if (
          getSystemSettings(generalSettings, "print_callcenter_kot") === "1" && !hold
        ) {
          if (res.data[0] && local == false) {
            directPrint ? handleLocalPrint(local) : setNextKotPrint();
          }
        } else if (local == false) {
          res.data[0] && handleOrderSubmitSuccessful();
        }
      }

      //set work period
      let theWorkPeriod = null;
      if (
        orderDetails.branch !== undefined &&
        orderDetails.branch !== null &&
        (authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager")
      ) {
        theWorkPeriod =
          res.data[0] &&
          res.data[0].find((tempWorkPeriod) => {
            return (
              orderDetails.branch.id === parseInt(tempWorkPeriod.branch_id)
            );
          });
      } else {
        theWorkPeriod = res.data[0][0];
      }

      //set work period here
      if (authUserInfo && (authUserInfo.details.user_type === "call_center") && parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1) {
        setNewSettings({
          ...newSettings,
          workPeriod: null
        })
      } else {
        setNewSettings({
          ...newSettings,
          vat: orderDetails.branch.branch_tax,
          workPeriod: theWorkPeriod !== undefined ? theWorkPeriod : null,
        });
      }

      setTheTax(orderDetails.branch.branch_tax);

      getRunningOrders();
      setLoading(false);

      //check sales limit target
      // if(authUserInfo.details.user_type === "staff" && authUserInfo?.details?.sales_limit > 0){
      //   if(res?.data[4] > authUserInfo?.details?.sales_limit){
      //     toast.success('Congratulations🎉, you have achieved your target!', {
      //       position: "top-left",
      //       autoClose: 7000,
      //       hideProgressBar: false,
      //       closeOnClick: true,
      //       pauseOnHover: true,
      //       hideProgressBar: true,
      //       // draggable: true,
      //       // progress: undefined,
      //       transition: Flip,
      //       style:{backgroundColor:"#ed8153"}
      //       });
      //   }
      // }
    } else {
      toast.error(`${_t(_t("Please restart the work period"))}`, toastObj);
      setLoading(false);
      setButtonDisabled(false);
    }
  };

  const tokenNumber = () => {
    if (!orderDetails.token?.id || typeof (orderDetails.token) !== "object") {
      let tokenTemp = newSettings.workPeriod?.token;

      if (localStorage.getItem("order_id")) {
        tokenTemp = parseInt(localStorage.getItem("order_id")) + 1;
      }

      let userWiseToken = getSystemSettings(generalSettings, "user_wise_token") == 1;
      let userToken = "";
      const currentTime = new Date().getTime();
      if (userWiseToken) {
        userToken = authUserInfo?.details && authUserInfo.details?.name?.charAt(0).toUpperCase() + authUserInfo.details?.id + "-"
      }
      setOrderDetails((curr) => ({
        //set token here on first order item add,
        ...curr,
        unique_token: Number(currentTime + String(authUserInfo?.details?.id) + String(orderDetails.branch.id)),
        token: {
          time: currentTime,
          id: userWiseToken ? (userToken + tokenTemp) : String(tokenTemp), //token#
          prefix: userWiseToken ? userToken : "",
          order_id: null,
        },
      }));
    }
  };

  const validateOrder = () => {
    if (authUserInfo.details.user_type === "call_center" && parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1 && zoneArea && zoneArea?.minimum > 0 && (parseFloat(cartTotal) - parseFloat(deliveryCharges)) < zoneArea?.minimum) {
      toast.error(`${_t(t(`Minimum order for this zone is ${zoneArea.minimum}`))}`, toastObj);
      return false;
    }

    if (orderDetails.is_advance_booking) {
      if ((parseFloat(cartSubTotal) + parseFloat(theVat)) < Number(orderDetails.advance_amount)) {
        toast.error(`${_t(t("Advance amount should be less than total amount"))}`, toastObj);
        return false;
      }
      if (!orderDetails.pre_order_date) {
        toast.error(`${_t(t("Please select advance booking date"))}`, toastObj);
        return false;
      }
      if (!orderDetails.advance_amount) {
        toast.error(`${_t(t("Please enter advance amount"))}`, toastObj);
        return false;
      }
      if (!orderDetails.payment_type) {
        toast.error(`${_t(t("Please enter advance amount"))}`, toastObj);
        return false;
      }
    }

    if (authUserInfo.details.user_type === "call_center") {
      if (callCenterPayment.payment_type === "Online" && !callCenterPayment.transaction_no) {
        toast.error(`${_t(_t("Please enter transaction id"))}`, toastObj);
        setCallCenterPayment({
          ...callCenterPayment,
          transactionModal: true
        })
        return false;
      }
    }

    if (authUserInfo.details.user_type === "call_center") {
      if (orderDetails.newCustomerInfo.name == "" && !orderDetails.newCustomerInfo?.is_confirm) {
        setModal9Show(true);
        toast.error(`Please ${orderDetails.newCustomerInfo.name == "" ? "fill customer name &" : ""} press confirm`);
        return false;
      }
    }

    if (!orderDetails.token?.id || typeof (orderDetails.token) !== "object") {
      tokenNumber();
      return false;
    }

    if (orderDetails.orderTypeDetails === undefined || orderDetails.orderTypeDetails === null) {
      toast.error(`${_t(_t("Submit order to select order type"))}`, toastObj);
      return false;
    }

    if (
      selectedDeliveryType?.name?.match(/dine(.*)in/i) && (parseInt(orderDetails.branch?.table_waiter) || parseInt(getSystemSettings(generalSettings, "table_waiter")) === 1) &&
      (orderDetails?.table_id === null || (orderDetails?.table_id && orderDetails.table_id?.length === 0))
    ) {
      toast.error(`${_t(t("Please confirm table first"))}`, toastObj);
      setModal10Show(true);
      return false;
    }

    if (parseInt(JSON.parse(getSystemSettings(generalSettings, "customer_validation"))[selectedDeliveryType.name]) === 1) {
      if (orderDetails.newCustomerInfo.name == "" || orderDetails.newCustomerInfo.phn_no == "" || !orderDetails.newCustomerInfo?.is_confirm) {
        setModal9Show(true);
        toast.error(`Please fill customer ${orderDetails.newCustomerInfo.name == "" ? "name" : ""} ${orderDetails.newCustomerInfo.name == "" && orderDetails.newCustomerInfo.phn_no == "" ? "&" : ""} ${orderDetails.newCustomerInfo.phn_no == "" ? "phone number" : ""} & press confirm`);
        return false;
      }
    }

    if (
      selectedParty?.name.match(/food(.*)panda/i) && parseInt(selectedParty.show_ref_no) === 1 &&
      orderDetails.newCustomerInfo.ref_no?.length < selectedParty.ref_min && !order_id
    ) {
      toast.error(
        `${_t(t(`Please enter ref no between ${selectedParty.ref_min}-${selectedParty.ref_max} digits`))}`,
        toastObj
      );
      return false;
    }

    if (isNaN(cartTotal)) {
      toast.error(`${_t(_t("Total amount can't be NaN"))}`, { ...toastObj, toastId: "nan-total-error" });
      return false;
    }

    if (paidMoney !== 0) {
      toast.error(
        `${_t(_t("Settle order to add payments, or remove payment's amount"))}`,
        toastObj
      );
      return false
    }

    if (!newOrder || newOrder?.length === 0) {
      toast.error(`${_t(_t("Please add items in order list"))}`, { ...toastObj, toastId: "empty-order-list" });
      setButtonDisabled(false);
      return false
    }

    return true
  }

  //pre order
  const axiosPreOrder = async () => {
    let api = order_id ? "/settings/order-update"
      : (authUserInfo.details.user_type === "call_center"
        ? "/settings/new-callcenter-order"
        : "/settings/pre-order");

    let url = BASE_URL + api;
    let localCurrency = JSON.parse(localStorage.getItem("currency"));
    let formData = getOrderObject(localCurrency);
    formData.pre_order_date = orderDetails.pre_order_date;
    formData.advance_amount = orderDetails.advance_amount;

    setLoading(true);
    networkStatus = await checkNetworkStatus();
    if (networkStatus && parseInt(authUserInfo.details?.offline_enable) === 1 && !syncOrder) {
      syncLocalOrders();
    }
    axios
      .post(url, formData, {
        headers: {
          Authorization: `Bearer ${getCookie()}`,
          "Content-Type": "application/json", 
        },
      })
      .then((res) => {
        if (res.data === "exists") {
          toast.error(`${_t(_t("Order already submit, You have click submit button again & again"))}`, { ...toastObj, toastId: "duplicate-order-submit" });
          setSelectedKot({});
          setButtonDisabled(false);
          setLoading(false);
          return false
        }
        setOrderDetails((curr) => ({ ...curr, pre_order_modal: false }))
        handleCreateOrUpdateOrder(res, false, 0);
        setLoading(false);

      })
      .catch((error) => {
        if (parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 && error.response?.data?.message !== "") {
          toast.error(<span style={{ whiteSpace: "pre-line" }}>{error.response.data.message}</span>, toastObj);
          setSelectedKot({});
          setButtonDisabled(false);
          setLoading(false);
          return false
        }

        setFoodGroupsToPrint({});
        setKotPrintIdx(0);
        setSelectedKot({});
        let data = [];
        data.push(workPeriodListForBranch);
        //set work period
        let theWorkPeriod = null;
        if (
          orderDetails.branch !== undefined &&
          orderDetails.branch !== null &&
          (authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager")
        ) {
          theWorkPeriod =
            data[0] &&
            data[0].find((tempWorkPeriod) => {
              return (
                (orderDetails.branch.id === parseInt(tempWorkPeriod.branch_id)) && tempWorkPeriod.ended_at === null
              );
            });
        } else {
          theWorkPeriod = data && data[0][0];
        }
        setLoading(false);
        setTimeout(() => {
          setNewSettings({
            ...newSettings,
            vat: orderDetails.branch.branch_tax,
            workPeriod:
              theWorkPeriod !== undefined ? theWorkPeriod : null,
          });
        }, 500);
        if (error.response?.data?.status == 1) {
          toast.error(`${_t(_t(error.response.data?.message))}`, toastObj);
        } else if (networkStatus) {
          toast.error(`${_t(_t("Please contact support"))}`, { ...toastObj, toastId: "contact-support-error" });
        } else {
          toast.error(`${_t(_t("Please check your internet connection"))}`, { ...toastObj, toastId: "network-error" });
        }
        setButtonDisabled(false);
      });
  }

  const handlePreOrder = (e) => {
    e.preventDefault();
    if (orderDetails.pre_order_date) {
      setOrderDetails({ ...orderDetails, pre_order_modal: false })
      setButtonDisabled(true);
      axiosPreOrder();
    } else {
      toast.error(`${_t(_t("Please select pre order time"))}`, toastObj);
      setButtonDisabled(false);
    }
  };

  const handleSubmitOrder = (e, hold = 0, foc = 0, focManagerId = null) => {
    e.preventDefault();
    if (validateOrder()) {
      setButtonDisabled(true);
      axiosRequest(hold, foc, focManagerId);
    }
  };

  const getOrderObject = (localCurrency, focManagerId = null) => {
    const finalManagerId = focManagerId || managerId;
    // add one extra field in formdata if callcenter
    let partyFinal = {
      partyId: selectedParty && selectedParty.id,
      partyName: selectedParty && selectedParty.name,
      partyPercent: selectedParty && selectedParty.receivable_amount,
      partyRefNo: selectedParty && selectedParty.show_ref_no,
      associate_with_payment_type: selectedParty && selectedParty.associate_with_payment_type,
      party_for_cc: selectedParty && selectedParty.for_cc
    };

    let orderTypeFinal = {
      orderTypeId: selectedDeliveryType && selectedDeliveryType.id,
      orderTypeName: selectedDeliveryType && selectedDeliveryType.name,
    };

    if (
      (!orderTypeFinal && !orderTypeFinal?.orderTypeId) ||
      (!partyFinal && !partyFinal?.partyId)
    ) {
      let error = "";
      if (
        !selectedParty ||
        !selectedParty.id ||
        (!partyFinal && !partyFinal.partyId)
      )
        error = "party";
      if (
        !selectedDeliveryType ||
        !selectedDeliveryType.id ||
        (!orderTypeFinal && !orderTypeFinal?.orderTypeId)
      )
        error = "delivery type";
      if (error) {
        toast.error(`Please select ${error} first.`);
        return false;
      }
    }

    let formData = {
      type: "submit",
      branch: orderDetails.branch,
      table: orderDetails.table,
      ...(parseInt(authUserInfo?.details?.offline_enable) === 1 && authUserInfo.details.user_type !== "call_center" ? {
        dept_tag_id: selectedDeptTag?.id,
        dept_tag_name: selectedDeptTag?.name,
        waiter_id: orderDetails.waiter ? orderDetails.waiter.id : "",
        waiter_name: orderDetails.waiter ? orderDetails.waiter.name : "",
      } : {
        dept_tag: selectedDeptTag,
        waiter: orderDetails.waiter,
      }),
      card_number: orderDetails.card_number,
      ...(authUserInfo.details.user_type !== "call_center" && {
        manager_id: finalManagerId ? finalManagerId : null,
        advance_payment: orderDetails.advance_amount,
        is_advance_booking: orderDetails.is_advance_booking,
        time_to_deliver: orderDetails.pre_order_date ?? "",
      }
      ),
      ...(authUserInfo.details.user_type === "call_center" && {
        payment_method: callCenterPayment.payment_type,
        transaction_no: callCenterPayment.transaction_no,
        foodPanda_ref_no: orderDetails.newCustomerInfo.ref_no,
        area_name: area?.name ?? "",
      }
      ),
      payment_type: orderDetails.payment_type,
      payment_amount: orderDetails.payment_amount,
      customerInfo: orderDetails.newCustomerInfo,
      note_to_rider: orderDetails.note_to_rider,
      token: orderDetails.token,
      unique_token: orderDetails.unique_token,
      total_guest: orderDetails.total_guest,
      //is_reservation: orderDetails.is_reservation,
      table_id: orderDetails.table_id,
      table_name: orderDetails.table_name,
      discount: orderDetails.discount,
      orderItems: newOrder,
      ...(order_id && { delete_items: Object.values(deletedItemsOnEdit) }),
      serviceCharge: deliveryCharges,
      scheme: orderDetails.scheme,
      subTotal: cartSubTotal,
      totalPayable: cartTotal,
      paidMoney: paidMoney,
      theVat: theVat,
      tax_percent: theTax > 0 ? theTax : orderDetails.branch.branch_tax,
      service_amount: serviceCharges,
      dept_commission: selectedDeptTag?.commission,
      localCurrency: localCurrency,
      workPeriod: newSettings.workPeriod,
      order_id: order_id ? order_id : null,
      orderTypeDetails: orderTypeFinal?.orderTypeId
        ? orderTypeFinal
        : orderDetails.orderTypeDetails,
      partyDetails: partyFinal?.partyId
        ? partyFinal
        : orderDetails.partyDetails,
    };

    handleKotItems();

    return formData;

    // newOrder.map((key, value) => {
    //   // console.log("2866items", value, key);
    //   selectedKot[key.item.kot] = key;
    //   setSelectedKot(selectedKot);
    // });
    // console.log("2866items", selectedKot);
  };

  //set branch on edit
  const handleSetBranchOnEdit = (branch) => {
    setLoading(true);
    
    if (stockListenerRef.current) stockListenerRef.current();
    
    if (parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 && (authUserInfo.details.user_type !== "staff" && authUserInfo.details.user_type !== "manager")) {
      stockListenerRef.current = fetchStock(branch);
    }
    setSelectedBranch(branch);
    // setOrderDetails((curr)=>({
    //   ...curr,
    //   branch: branch,
    // }));
    //set branch tax
    if (branch) {
      setTheTax(branch.branch_tax)
    } else {
      setTheTax(0);
    }
    setLoading(false);
  };

  const handleSetBranch = (branch) => {
    setLoading(true);
    if (order_id) {
      if (!buttonDisabled && cartItems && Object.keys(cartItems)?.length > 0) {
        toast.error("You can't change branch while order is in progress", toastObj);
        return
      }
    }
    if (parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 && orderDetails?.branch?.id !== branch?.id) {
      if (stockListenerRef.current) stockListenerRef.current();
      stockListenerRef.current = fetchStock(branch);
    }
    if (parseInt(getSystemSettings(generalSettings, "call_center_enable")) === 1 && branch && selectedDeliveryType) {
      handleFilterScheme(branch, selectedDeliveryType);
    }
    if (authUserInfo.details.user_type === "call_center") {
      workPeriodStatus(branch.id);
    }
    let theWorkPeriod = null;
    theWorkPeriod =
      workPeriodListForBranch &&
      workPeriodListForBranch.find((tempWorkPeriod) => {
        return (branch.id === parseInt(tempWorkPeriod.branch_id)) && tempWorkPeriod.ended_at === null;
      });
    // let selectedBranch = null;
    // selectedBranch = Array.from(theWorkPeriod).find((item) => {
    //   return branch.id === parseInt(item?.branch_id);
    // });
    // console.log("grop2222",selectedBranch,theWorkPeriod)
    setCashDetails({
      ...cashDetails,
      branch_id: branch.id,
      branch_name: branch?.name,
      work_period_id: branch?.id,
    });
    setNewSettings({
      ...newSettings,
      workPeriod: theWorkPeriod ? theWorkPeriod : null,
      vat: branch.branch_tax,
    });

    if (!order_id && authUserInfo.details.user_type !== "call_center") {
      setSelectedDeliveryType();
      setSelectedParty();
    }
    setOrderDetails((curr) => ({
      ...curr,
      branch: branch,
    }));
    setSelectedBranch(branch);
    handleFilterDept(branch.id);
    //set branch tax
    setTheTax(branch.branch_tax)
    // empty card
    emptyCardOnChange();
    setLoading(false);
  };

  //search food here
  const handleSearch = (e) => {
    setSearchInput(e.target.value);
    let searchinput = e.target.value;
    if (searchinput.length === 0) {
      setSearchedFoodItem({ list: null, searched: false });
    } else {
      const foodSearch = menuForPos && orderDetails.branch && selectedDeptTag?.id ? Object.values(menuForPos[orderDetails.branch?.id][selectedDeptTag.id]).flat() : [];
      const deptFood = foodSearch &&
        foodSearch?.filter((item) => {
          let lowerCaseItemName = item?.name && item.name.toLowerCase();
          let sku = item?.sku && item.sku.toLowerCase();
          return (
            (lowerCaseItemName.includes(searchinput.toLowerCase()) ||
              (sku && sku.includes(searchinput.toLowerCase()))) &&
            // JSON.parse(item.menu_ids).includes(selectedDeptTag?.id) && 
            item.food_group_status
          );
        });
      // for (const key in menu[selectedDeptTag?.id]) {
      //   deptFood.push(...menu[selectedDeptTag?.id][key]);
      // }
      // let searchedList = deptFood && deptFood.filter((item) => {
      //   let lowerCaseItemName = item.name.toLowerCase();
      //   return lowerCaseItemName.includes(searchinput);
      // });

      setSearchedFoodItem({
        ...searchedFoodItem,
        list: deptFood,
        searched: true,
      });
    }
  };

  //show price of each item in order list without discount
  // const showPriceOfEachOrderItemWithoutDiscount = (itemIndex) => {
  //   if (newOrder) {
  //     let price = 0;
  //     let dis = 0;
  //     let inclusive_vat = 0;
  //     let after_tax_price = 0;
  //     let orderItem = newOrder[itemIndex];
  //     //check price * quantity (variation price / item price)
  //     if (parseInt(orderItem.item.has_variation) === 1) {
  //       price = parseFloat(orderItem.variation.food_with_variation_price);
  //     } else {
  //       price = parseFloat(orderItem.item.price);
  //     }
  //     //calculate total price of properties
  //     if (orderItem.properties) {
  //       if (orderItem.properties.length > 0) {
  //         orderItem.properties.map((getEachItemPrice) => {
  //           let totalPropertyPrice =
  //             parseFloat(getEachItemPrice.item.extra_price) *
  //             getEachItemPrice.quantity;
  //           price = price + totalPropertyPrice;
  //         });
  //       }
  //     }

  //     if (getSystemSettings(generalSettings, "tax_type") === "inclusive") {
  //       if (newSettings) {
  //         inclusive_vat = (parseFloat(newSettings.vat) + 100) / 100;
  //         after_tax_price = price / inclusive_vat;
  //         inclusive_vat = (price - after_tax_price) * orderItem.quantity;
  //         price = after_tax_price;
  //       }
  //     }
  //     let formattedPrice = formatPrice(price * orderItem.quantity);
  //     return formattedPrice;
  //   }
  // };

  //show price of each item in print
  // const showPriceOfEachOrderItemPrint = (itemIndex) => {
  //   if (newOrder) {
  //     let price = 0;
  //     let dis = 0;
  //     let dis_amount = 0;

  //     let orderItem = newOrder[itemIndex];

  //     if (orderItem.discount !== undefined) {
  //       dis = parseFloat(orderItem.discount);
  //     } else {
  //       dis = 0;
  //     }

  //     //check price * quantity (variation price / item price)
  //     if (parseInt(orderItem.item.has_variation) === 1) {
  //       const tempPrice = parseFloat(
  //         orderItem.variation.food_with_variation_price
  //       );
  //       price = roundOffPrice(getBeforeTaxPrice(tempPrice));
  //     } else {
  //       const temprice = parseFloat(orderItem.item.price);
  //       price = roundOffPrice(getBeforeTaxPrice(temprice));
  //     }

  //     let formattedPrice = 0;
  //     if (orderItem.discount_type === "percentage") {
  //       dis_amount = (price / 100) * dis;
  //       formattedPrice = formatPrice(
  //         price * orderItem.quantity - dis_amount * orderItem.quantity
  //       );
  //     } else {
  //       formattedPrice = formatPrice(
  //         price * orderItem.quantity - dis * orderItem.quantity
  //       );
  //     }

  //     //let formattedPrice = formatPrice(price * orderItem.quantity - 10);
  //     return formattedPrice;
  //   }
  // };

  const handlePunchOrder = () => {
    let phn_no = orderDetails?.newCustomerInfo?.order?.phn_no;
    if (!phn_no) {
      toast.error("Phone number is required", toastObj);
      return;
    }
    const url = BASE_URL + "/settings/last-order-repeat";
    setLoading(true);
    axios.get(url, {
      params: { phn_no },
      headers: { Authorization: `Bearer ${getCookie()}` }
    })
    .then((res) => {
      setLoading(false);
      const data = res.data[0];
      if (data) {
        const orderItem = data.orderItems;
        let newData = {};
        for (const key in orderItem) {
          const item = orderItem[key]
          const card = {
            ...item.item,
            price: item.item.price
              ? item.item.price
              : item.variation.food_with_variation_price,
          };
          const selectedCard = {
            ...item,
            item: {...card, has_variation: String(card.has_variation), ...(card?.stock_qty >= 0 && { stock_qty: Number(item.quantity) + card.stock_qty })},
          };
          let cardProperties = {};
          for (const index in selectedCard.properties) {
            let Properties = selectedCard.properties[index];
            if(parseInt(authUserInfo?.details?.offline_enable) === 1){
              const {quantity, ...prpItem} = selectedCard.properties[index];
              Properties = {
                item: {
                  ...prpItem,
                  name:prpItem.property, 
                  extra_price: prpItem.price_per_qty,
                  id: prpItem.property_id,
                },
                quantity: parseInt(quantity),
              }
            }
            let Propertygroup = data?.selected_property_group_ids?.[key] && data?.selected_property_group_ids[key][index] 
              ? data.selected_property_group_ids[key][index] : JSON.parse(Properties.item.property_group_id)[0];
            const propertyId = Properties.item.id;
            cardProperties[Propertygroup] = cardProperties[Propertygroup]
              ? {
                  ...cardProperties[Propertygroup],
                  [propertyId]: { ...Properties },
                }
              : { [propertyId]: Properties };
          }
          // item payload on edit
          const items = {
            ...selectedCard,
            new: true,
            quantity: Number(selectedCard.quantity),
            variation: (parseInt(card.has_variation) === 1) ? selectedCard.variation : null,
            properties: parseInt(card.has_property) === 1 ? cardProperties : null,
          }
          let schemeToApply = checkScheme(items);
          const afterTaxPrice = roundOffPrice(getBeforeTaxPrice(calculatePriceForCartItem(items, items.quantity)));
          let schemePrice = schemeToApply?.discount_addon === "discount_without_addon" ? getBeforeTaxPrice(calculatePriceForCartVariation(items, items.quantity)) : afterTaxPrice;
          if (schemeToApply?.discount_tax) {
            schemePrice += roundOffPrice(getTaxPrice(afterTaxPrice, orderDetails?.payment_discount || theTax))
          }
          let disItemQty = items.quantity;
          if(schemeToApply?.qty){
            disItemQty = parseInt(items.quantity / schemeToApply.qty)
            schemePrice = disItemQty ? ((schemePrice / items.quantity) * disItemQty) : 0;
          }
      
          items.after_tax_price = afterTaxPrice;
          items.discount = schemeToApply
            ? parseFloat(schemeToApply.how_much_discount)
            : 0;
          items.item_discount = (schemeToApply ? roundOffPrice(getInitialItemDiscount(schemePrice, schemeToApply)) : 0);
          items.discount_type = schemeToApply ? schemeToApply.discount_type : "";
          // if(isWeb && taxType){
          //   items.after_tax_price = parseFloat(getBeforeTaxPrice(calculatePriceForCartItem(items, items.quantity),taxType,tax))
          // }
          let hashId = createHash(items);
          if(item.status === "complimentory" || item.status ===  "foc"){
            hashId += item.status
          }
      
          if(newData[hashId]){
            newData = {
              ...newData,
              [hashId]: {
                ...newData[hashId],
                item_discount: Number(newData[hashId].item_discount) + Number(items.item_discount),
                after_tax_price: Number(newData[hashId].after_tax_price) + Number(items.after_tax_price),
                discount: Number(newData[hashId].discount) + Number(items.discount),
                quantity: Number(newData[hashId].quantity) + Number(items.quantity),
              },
            };
          }else{
            newData = {
              ...newData,
              [hashId]: {
                ...items,
                seq: Object.keys(newData)?.length + 1,
              },
            }
          }
        }
        setCartItems(newData);
        setOrderDetails((curr)=>({...curr, newCustomerInfo: { ...curr.newCustomerInfo, modal: false }}));
        toast.success("Order punched successfully", toastObj);
      }
    })
    .catch((err) => {
      setLoading(false);
      toast.error("Failed to punch order", toastObj);
    });
  };

  return {
    t,
    showSettle,
    buttonDisabled,
    availableDeptTags,
    selectedDeptTag,
    handleDeptTag,
    handleSearch,
    setSearchedFoodItem,
    searchInput,
    inputSearch,
    activeFoodGroup,
    handleFoodGroup,
    availableFoodGroups,
    orderCounter,
    onlineOrder,
    availableDeliveryTypes,
    selectedDeliveryType,
    selectedParty,
    handleDeliveryType,
    handleSelectedParty,
    runningOrders,
    editOrder,
    authUserInfo,
    modal9Show,
    setModal9Show,
    modalOrderType,
    setModalOrderType,
    setOrderDetails,
    orderDetails,
    newSettings,
    generalSettings,
    handleSetBranch,
    zoneArea,
    setZoneArea,
    area,
    setArea,
    setDeliveryCharges,
    selectedBranch,
    setEditOrder,
    setModal10Show,
    taxHeight,
    setItemImage,
    itemImage,
    selectTable,
    setSelectTable,
    tableId,
    setSelectedKot,
    selectedKot,
    setShowSettle,
    setButtonDisabled,
    setSearchInput,
    discountInput,
    cartSubTotal,
    setExpanded,
    setCatInOneLine,
    CatInOneLine,
    calculateTax,
    isLocked,
    authenticateStaffUser,
    onSuccessAuthenticationStaff,
    showPasswordPopup,
    hanleCancelAuthenticate,
    handleCardSubmit,
    cardModal,
    order_id,
    availableDeliveryParties,
    managerId,
    cartItems,
    setCartItems,
    cartTotal,
    deliveryCharges,
    roundOffPrice,
    getBeforeTaxPrice,
    theVatSettle,
    setTheVatSettle,
    setPaidMoney,
    setNewSettings,
    totalsettle,
    setTotalSettle,
    paidMoney,
    serviceCharges,
    foodItem,
    setFoodItem,
    loyaltyPoint,
    setloyaltyPoint,
    emptyCardOnChange,
    tokenNumber,
    theVat,
    theTax,
    setTheVat,
    returnMoneyUsd,
    setReturnMoneyUsd,
    isSettle,
    handleLocalPrint,
    handleReceiptPrint,
    handleKotItems,
    paymentTypeAvailable,
    fbrInvoiceNum,
    srbInvoiceNum,
    token_No,
    newOrder,
    foodGroupsToPrint,
    con_Kot,
    taxType,
    component2Ref,
    managerPasscode,
    setComponentUnlock,
    setManagerId,
    componentUnlock,
    backModal,
    setBackModal,
    emptyCard,
    cashDetails,
    setCashDetails,
    noteRiderModal,
    setNoteRiderModal,
    handlePreOrder,
    addReasonOnSubmit,
    addFocItem,
    setAddFocItem,
    setAddReasonModalShowing,
    addReasonModalShowing,
    deleteReason,
    setDeleteReason,
    setPaymentTypeModalState,
    paymentTypeModalState,
    callCenterPayment,
    setCallCenterPayment,
    workPeriodScreen,
    branchForSearch,
    searchedFoodItem,
    flyStart,
    animate,
    handleFoodItemClicked,
    handleCloseItemModal,
    menuWisePrice,
    showModal,
    expanded,
    selectedFoodItem,
    selectedFoodItemId,
    addToCart,
    cardAnimate,
    deleteCartItem,
    editCartItem,
    deleteOneCartItem,
    commentFocus,
    handleSetItemQty,
    handleSetItemPrice,
    handleSetItemDiscount,
    deletedItemsOnEdit,
    setCommentId,
    userLock,
    itemAdd,
    modal10Show,
    setTableId,
    guestSelected,
    setGuestSelected,
    commentId,
    updateItemImage,
    updateComments,
    taxScroll,
    handleTaxOnPaymentTypeChange,
    deliveryInput,
    hanldeDiscountPercent,
    toastObj,
    tempSchemeForSearch,
    schemeForSearchObj,
    handleSetOffer,
    paymentOptions,
    currentNavPill,
    handlePaymentType,
    loading,
    handleSubmitOrder,
    handlePreOrderConfirmation,
    handleSettleOrderButton,
    handleFocConfirmation,
    handleFocItem,
    barcodePrintRef,
    componentRef,
    setShowordertypeModal,
    showordertypeModal,
    syncOrder,
    syncLocalOrders,
    handlePunchOrder,
    isFoodLoading
  }
}

export default usePosLogics